import { helpEn } from "./help.en";

export const languageEnglish = {
    formating: {
        main: "Main Prompt",
        jailbreak: "Jailbreak Prompt",
        chats: "Past Chats",
        lorebook: "Lorebook",
        globalNote: "Global Note",
        authorNote: "Author's Note",
        lastChat: "Last Chat",
        description: "Character Description",
        personaPrompt: "Persona Prompt",
        plain: "Plain Prompt",
        memory: "Supa/HypaMemory",
        postEverything: "End-Injected Prompts",
    },
    errors: {
        toomuchtoken: "Error: The minimum required token is greater than the Max Context Size.",
        unknownModel: "Error: Unknown model selected",
        httpError: "Error: error in request:",
        noData: "The file is invalid, or its data is corrupted.",
        onlyOneChat: "There must be least one chat",
        onlyOnePreset: "There must be at least one preset",
        noUserIcon: "You must set your icon first.",
        emptyText: "Text is empty.",
        wrongPassword: "Wrong Password",
        coldStorageWriteFailed: "Cold storage write failed. Your chat data has been preserved.",
        coldStorageVerifyFailed: "Cold storage verification failed. Your chat data has been preserved.",
        vertexAuthError: "Vertex AI authentication details are missing.",
        networkFetch: "This happens when the network is unstable or the server is down.",
        networkFetchWeb:
            "This can be a CORS error. this only happens when using web version due to limitations of the browser. try using desktop local version, or other version of PocketRisu.",
        networkFetchPlain: "This can be a plain fetch error. try disabling force plain fetch option in settings.",
        requestLogRemoved: "This request log is removed.",
        requestLogRemovedDesc: "This request log removes when client is refreshed or reloaded.",
        persistFailureTitle: "Server save failed — changes are not being written to disk",
        persistFailureAttemptedSize: "attempted size",
        storageRequestTooLarge: "Save request failed because it is too large (HTTP 413). Check the request body size limit on the server or reverse proxy (Nginx, etc.).",
        chatGuardTitle: "Chat data guard triggered — switched to safe save mode",
        chatGuardDesc: "Suspicious save patterns blocked. Your changes will be persisted via the safe full-write fallback. If this keeps happening, please report it with browser console logs.",
        chatGuardPersistTitle: "Save aborted to protect existing chat data",
        backgroundGenerationFailed: "Background generation failed ({char}): {error}",
        modelJobBusy: "This chat is still generating on the server. It will fill in automatically when it finishes — please wait a moment.",
        modelJobConnectionLost: "The connection dropped, but the server is still generating. It will resume automatically when you come back — no need to send again.",
        chatStillGenerating: "This chat is still generating. Wait for it to finish or stop it, then send again.",
        otherChatGenerating: "Another chat is still generating. Wait for it to finish or stop it, then send again.",
        chatGuardPersistDesc: "Server detected corrupted chat structure mid-persist and refused to write to disk. Your latest changes may NOT be on disk yet — re-verify before refreshing. Existing data is safe.",
        assetManifestConflictTitle: "Asset list changed in another session",
        assetManifestConflictDesc: "The latest asset page has been reloaded. Please review it and retry your edit.",
    },
    showHelp: "Show Help",
    help: helpEn,
    setup: {
        chooseProvider: "Choose AI Provider",
        openaikey: "OpenAI with API Key (Recommended)",
        openaiProxy: "OpenAI Reverse proxy",
        setupmodelself: "Others / I will setup myself",
        inputApiKey: "Input API Key Here",
        apiKeyhelp: "You can get api key from: ",
        setupSelfHelp: "Setup yourself in settings, after Welcome screen ends.",
        theme: "Select your theme",
        themeDescWifulike: "Not suitable for mobile",
        themeDescWifuCut: "Suitable for mobile",
        themeDescClassic: "Suitable for All devices",
        texttheme: "Select your text color",
        inputName: "Lastly, Input your Nickname.",
        welcome: "Welcome to PocketRisu! I am Airisu, I am here guide you to setup PocketRisu. First, What may I call you?",
        welcome2: "Hello {username}! before we start, I will ask you some questions. You can change these settings later in settings.\n\nFirst select the AI provider.",
        openRouterProvider: "OpenRouter has a lot of models, some of them unfiltered and some of them free, but it is not as good as OpenAI.",
        hordeProvider: "Horde is a free provider, but the response time is long and the quality is low.",
        setProviderLater: "There are other providers, but you can set it later in settings. select this if you want to set it later.",
        setupOpenAI:
            "To use OpenAI, you need to get an API key. \n1. go to https://beta.openai.com/ \n2. login with your account \n3. go to https://beta.openai.com/account/api-keys \n4. click 'Create New API Key' and name your key whatever you want. \n5. copy the key in the website.\n6. go back to PocketRisu\n7. paste it, and click send button.",
        setupClaude: "To use Claude, you need to get an API key.",
        setupClaudeSteps: [
            "Go to this URL and Login as Google",
            "Input your information and click 'Continue'",
            "On organization page, just input any name only at the first box, and click 'Create Account'",
            "Press 'Buy Credits' button",
            "Press 'Complete Setup' button",
            "Input just like the image above, except the country section, which you need to input your country. then press 'Continue'",
            "Add your payment method and press 'Continue'",
            "After payment has been registered, press 'Add Funds' and add funds. you can add minimum 5$, or you can setup auto add reload.",
            "After adding funds, go to the dashboard page and press 'Get API Keys' button",
            'Press "Create API Key" button',
            "Input just like the image above, and press 'Add'",
            "Copy the key, and paste it in here and send it.",
        ],
        setupOpenRouter:
            "To use OpenRouter, you need to get an API key. \n1. go to https://openrouter.ai/keys\n2. click 'Create Key'\n3. set key name whatever you want.\n4. copy the key in the website\n5. go back to PocketRisu\n6. paste it, and click send button.",
        allDone: "All Done! please wait a moment.",
        setupLaterMessage: "Welcome {username}! do you want me to guide you to setup or do it yourself?",
        setupMessageOption1: "Guide me to setup",
        setupMessageOption1Desc: "Recommended for new users",
        setupMessageOption2: "I will setup myself",
        claudeDesc: "Claude is a AI model made by Antropic, competitor to OpenAI. its better than GPT if you want to use it in other languages than English.",
        openAIDesc: "OpenAI GPT is a high quality AI model, but it is paid and filtered, and weak in other than English.",
        chooseChatType: "Great! Now select the chat language.",
        chooseChatTypeOption1: "Full English",
        chooseChatTypeOption1Desc: "This will make AI to use English and input/output in English. Recommended for English speakers.",
        chooseChatTypeOption2: "English Processing",
        chooseChatTypeOption2Desc: "This will make AI to use English internaly, but input/output will be in your language. Recommended for non-English speakers.",
        chooseChatTypeOption3: "No Language Focused",
        chooseChatTypeOption3Desc: "This will make AI to use your language internaly, but this could make quality lower.",
        chooseCheapOrMemory: "By the way, do you prefer memory or cheapness?",
        chooseCheapOrMemoryOption1: "Memory",
        chooseCheapOrMemoryOption1Desc: "This will make AI to remember more, but it will quite expensive.",
        chooseCheapOrMemoryOption2: "Cheap",
        chooseCheapOrMemoryOption2Desc: "This will make AI to remember less, but it will be cheaper.",
        chooseCheapOrMemoryOption3: "Balanced",
        chooseCheapOrMemoryOption3Desc: "This will make AI to remember more than cheap, but less than memory.",
        chooseCheapOrMemoryOption4: "Unlimited",
        chooseCheapOrMemoryOption4Desc: "This will make AI to remember almost everything, but it will be very expensive.",
        finally: "Finally, do you want to enable advanced tools?",
        finallyOption1: "Yes",
        finallyOption1Desc: "This will enable advanced tools, but it will make the UI more complex. Recommended for advanced users.",
        finallyOption2: "No",
        finallyOption2Desc: "This will disable advanced tools, and make the UI more simple. Recommended for new users.",
        igpPrompt:
            "if IGP Prompt is not a blank, it will be executed after the main model request, after main model execution, as a emotion model, adding the result after the main model response.",
    },
    triggerCategories: {
        Special: "Special",
        Control: "Control",
        Chat: "Chat",
        "Low Level": "Low Level",
        Alert: "Alert",
        "Lorebook V2": "Lorebook V2",
        String: "String",
        Data: "Data",
        Array: "Array",
        Others: "Others",
        Deprecated: "Deprecated",
    },
    triggerDesc: {
        v2Header: "Header",
        v2HeaderDesc: "Header",
        v2If: "If",
        v2IfDesc: "If {{source}} {{condition}} {{target}}",
        v2Else: "Else",
        v2ElseDesc: "Else",
        v2EndIndent: "End Indent",
        v2EndIndentDesc: "End Indent",
        v2SetVar: "Set Variable",
        v2SetVarDesc: "Set Variable {{var}} {{operator}} {{value}}",
        v2Loop: "Loop Forever",
        v2LoopDesc: "Loop Forever",
        v2BreakLoop: "Break Loop",
        v2BreakLoopDesc: "Break Loop",
        v2RunTrigger: "Run Trigger",
        v2RunTriggerDesc: "Run Trigger {{target}}",
        v2ConsoleLog: "Console Log",
        v2ConsoleLogDesc: "Console Log {{source}}",
        v2StopTrigger: "Stop Trigger",
        v2StopTriggerDesc: "Stop Trigger",
        v2CutChat: "Cut Chat",
        v2CutChatDesc: "Cut Chat from {{start}} to {{end}}",
        v2ModifyChat: "Modify Chat",
        v2ModifyChatDesc: "Modify Chat at index {{index}} with {{value}}",
        v2SystemPrompt: "Add System Prompt",
        v2SystemPromptDesc: "Add System Prompt at {{location}} with {{value}}",
        v2Impersonate: "Send Chat",
        v2ImpersonateDesc: "Send Chat as {{role}} with {{value}}",
        v2Command: "Run Command",
        v2CommandDesc: "Run command with {{value}}",
        v2SendAIprompt: "Send AI Prompt",
        v2SendAIpromptDesc: "Send AI Prompt",
        v2ImgGen: "Image Generation",
        v2ImgGenDesc: "Generate image from {{value}}, negative from {{negValue}} => {{outputVar}}",
        v2CheckSimilarity: "Check Similarity",
        v2CheckSimilarityDesc: "Check similarity between {{source}} and {{value}} => {{outputVar}}",
        v2RunLLM: "Run Model",
        v2RunLLMDesc: "Send request to model from {{value}} => {{outputVar}}",
        v2ShowAlert: "Show Alert",
        v2ShowAlertDesc: "Show alert with {{value}}",
        v2ExtractRegex: "Extract Regex",
        v2ExtractRegexDesc:
            "Extract text from {{value}} with regex {{regexType}} {{regex}} and flags {{flagsType}} {{flags}}, then store result as {{resultType}} {{result}} => {{outputVar}}",
        v2RegexTest: "Regex Test",
        v2RegexTestDesc: "Test {{value}} with regex {{regex}} and flags {{flags}} => {{outputVar}}",
        v2GetLastMessage: "Get Last Message",
        v2GetLastMessageDesc: "Get Last Message => {{outputVar}}",
        v2GetMessageAtIndex: "Get Message at Index",
        v2GetMessageAtIndexDesc: "Get Message at Index {{index}} => {{outputVar}}",
        v2GetMessageCount: "Get Message Count",
        v2GetMessageCountDesc: "Get Message Count => {{outputVar}}",
        v2GetLorebook: "Get Lorebook",
        v2GetLorebookDesc: "Get Lorebook named {{target}} => {{outputVar}}",
        v2GetLorebookCount: "Get Lorebook Count",
        v2GetLorebookCountDesc: "Get Lorebook Count => {{outputVar}}",
        v2GetLorebookEntry: "Get Lorebook with index",
        v2GetLorebookEntryDesc: "Get Lorebook with index {{index}} => {{outputVar}}",
        v2SetLorebookActivation: "Set Lorebook Activation",
        v2SetLorebookActivationDesc: "Set Lorebook with index {{index}}'s activation state to {{value}}",
        v2GetLorebookIndexViaName: "Get Lorebook Index via Name",
        v2GetLorebookIndexViaNameDesc: "Get Lorebook Index via Name {{name}} => {{outputVar}}",
        v2ModifyLorebook: "Modify Lorebook",
        v2ModifyLorebookDesc: "Modify Lorebook named {{target}} with {{value}}",
        v2LoopNTimes: "Loop N Times",
        v2LoopNTimesDesc: "Loop {{value}} Times",
        v2Random: "Random",
        v2RandomDesc: "Random from {{min}} to {{max}} => {{outputVar}}",
        v2GetCharAt: "Get Character at Index",
        v2GetCharAtDesc: "Get Character at Index {{index}} from {{source}} => {{outputVar}}",
        v2GetCharCount: "Get Character Count",
        v2GetCharCountDesc: "Get Character Count from {{source}} => {{outputVar}}",
        v2ToLowerCase: "Convert to Lower Case",
        v2ToLowerCaseDesc: "Convert {{source}} to Lower Case => {{outputVar}}",
        v2ToUpperCase: "Convert to Upper Case",
        v2ToUpperCaseDesc: "Convert {{source}} to Upper Case => {{outputVar}}",
        v2SetCharAt: "Set Character at Index",
        v2SetCharAtDesc: "Set Character at Index {{index}} in {{source}} to {{value}} => {{outputVar}}",
        v2SplitString: "Split String",
        v2SplitStringDesc: "Split {{source}} by {{delimiter}} => {{outputVar}}",
        v2GetCharacterDesc: "Get Character Description",
        v2GetCharacterDescDesc: "Get Character Description => {{outputVar}}",
        v2SetCharacterDesc: "Set Character Description",
        v2SetCharacterDescDesc: "Set Character Description to {{value}}",
        v2GetPersonaDesc: "Get Persona Prompt",
        v2GetPersonaDescDesc: "Get Persona Prompt => {{outputVar}}",
        v2SetPersonaDesc: "Set Persona Prompt",
        v2SetPersonaDescDesc: "Set Persona Prompt to {{value}}",
        v2GetReplaceGlobalNote: "Get Replace Global Note",
        v2GetReplaceGlobalNoteDesc: "Get Replace Global Note => {{outputVar}}",
        v2SetReplaceGlobalNote: "Set Replace Global Note",
        v2SetReplaceGlobalNoteDesc: "Set Replace Global Note to {{value}}",
        v2GetAuthorNote: "Get Author Note",
        v2GetAuthorNoteDesc: "Get Author Note => {{outputVar}}",
        v2SetAuthorNote: "Set Author Note",
        v2SetAuthorNoteDesc: "Set Author Note to {{value}}",
        v2Comment: "Add Comment",
        v2CommentDesc: "{{value}}",
        v2DeclareLocalVar: "Declare Local Variable",
        v2DeclareLocalVarDesc: "Declare local variable {{var}} with value {{value}}",
        v2MakeArrayVar: "Make Array Variable",
        v2MakeArrayVarDesc: "Make Array Variable {{var}}",
        v2GetArrayVarLength: "Get Array Variable Length",
        v2GetArrayVarLengthDesc: "Get Length of Array Variable {{var}} => {{outputVar}}",
        v2GetArrayVar: "Get Array Variable",
        v2GetArrayVarDesc: "Get Value at Index {{index}} from Array Variable {{var}} => {{outputVar}}",
        v2SetArrayVar: "Set Array Variable",
        v2SetArrayVarDesc: "Set Value at Index {{index}} in Array Variable {{var}} to {{value}}",
        v2PushArrayVar: "Add to Array Variable",
        v2PushArrayVarDesc: "Add {{value}} to Array Variable {{var}}",
        v2PopArrayVar: "Remove last value from Array Variable and get",
        v2PopArrayVarDesc: "Remove last value from Array Variable {{var}} => {{outputVar}}",
        v2ShiftArrayVar: "Remove first value from from Array Variable and get",
        v2ShiftArrayVarDesc: "Remove first value from Array Variable {{var}} => {{outputVar}}",
        v2UnshiftArrayVar: "Add to Array Variable as first value",
        v2UnshiftArrayVarDesc: "Add {{value}} as first value of Array Variable {{var}}",
        v2SpliceArrayVar: "Add to Array Variable in Index",
        v2SpliceArrayVarDesc: "Add {{value}} as {{start}} value of Array Variable {{var}}",
        v2SliceArrayVar: "Slice Array Variable",
        v2SliceArrayVarDesc: "Slice Array Variable {{var}} from {{start}} to {{end}} => {{outputVar}}",
        v2GetIndexOfValueInArrayVar: "Get Index of Value in Array Variable",
        v2GetIndexOfValueInArrayVarDesc: "Get Index of {{value}} in Array Variable {{var}} => {{outputVar}}",
        v2RemoveIndexFromArrayVar: "Remove Index from Array Variable",
        v2RemoveIndexFromArrayVarDesc: "Remove Value at Index {{index}} from Array Variable {{var}}",
        v2JoinArrayVar: "Join Array",
        v2JoinArrayVarDesc: "Join Array {{var}} with {{delimiter}} => {{outputVar}}",
        v2MakeDictVar: "Make Dictionary Variable",
        v2MakeDictVarDesc: "Make Dictionary Variable {{var}}",
        v2GetDictVar: "Get Dictionary Value",
        v2GetDictVarDesc: "Get Value for Key {{key}} from Dictionary {{var}} => {{outputVar}}",
        v2SetDictVar: "Set Dictionary Value",
        v2SetDictVarDesc: "Set Value for Key {{key}} in Dictionary {{var}} to {{value}}",
        v2DeleteDictKey: "Delete Dictionary Key",
        v2DeleteDictKeyDesc: "Delete Key {{key}} from Dictionary {{var}}",
        v2HasDictKey: "Has Dictionary Key",
        v2HasDictKeyDesc: "Check if Dictionary {{var}} has Key {{key}} => {{outputVar}}",
        v2ClearDict: "Clear Dictionary",
        v2ClearDictDesc: "Clear Dictionary {{var}}",
        v2GetDictSize: "Get Dictionary Size",
        v2GetDictSizeDesc: "Get Size of Dictionary {{var}} => {{outputVar}}",
        v2GetDictKeys: "Get Dictionary Keys",
        v2GetDictKeysDesc: "Get All Keys from Dictionary {{var}} => {{outputVar}}",
        v2GetDictValues: "Get Dictionary Values",
        v2GetDictValuesDesc: "Get All Values from Dictionary {{var}} => {{outputVar}}",
        v2ConcatString: "Concatenate Strings",
        v2ConcatStringDesc: "Concatenate {{source1}} and {{source2}} => {{outputVar}}",
        v2GetLastUserMessage: "Get Last User Message",
        v2GetLastUserMessageDesc: "Get Last User Message => {{outputVar}}",
        v2GetLastCharMessage: "Get Last Character Message",
        v2GetLastCharMessageDesc: "Get Last Character Message => {{outputVar}}",
        v2GetFirstMessage: "Get First Message",
        v2GetFirstMessageDesc: "Get First Message => {{outputVar}}",
        v2GetAlertInput: "Get Alert Input",
        v2GetAlertInputDesc: "Get Alert Input => {{outputVar}}",
        v2GetAlertSelect: "Get Alert Select",
        v2GetAlertSelectDesc: "Get Alert Select {{display}} options {{value}} => {{outputVar}}",
        v2UnsupportedTrigger: "Unsupported Trigger",
        v2UnsupportedTriggerDesc: "Unsupported Trigger",
        v2GetDisplayState: "Get Display State",
        v2GetDisplayStateDesc: "Get Display State => {{outputVar}}",
        v2SetDisplayState: "Set Display State",
        v2SetDisplayStateDesc: "Set Display State to {{value}}",
        v2UpdateGUI: "Update GUI",
        v2UpdateGUIDesc: "Update GUI",
        v2UpdateChatAt: "Update Chat At Index",
        v2UpdateChatAtDesc: "Redraw chat at {{index}}",
        v2Wait: "Wait",
        v2WaitDesc: "Wait {{value}} seconds",
        v2GetRequestState: "Get Request Data Content",
        v2GetRequestStateDesc: "Get Request Content at {{index}} => {{outputVar}}",
        v2SetRequestState: "Set Request Data Content",
        v2SetRequestStateDesc: "Set Request Content at {{index}} to {{value}}",
        v2GetRequestStateRole: "Get Request Data Role",
        v2GetRequestStateRoleDesc: "Get Request Data Role at {{index}} => {{outputVar}}",
        v2SetRequestStateRole: "Set Request Data Role",
        v2SetRequestStateRoleDesc: "Set Request Data Role at {{index}} to {{value}}",
        v2GetRequestStateLength: "Get Request Data Length",
        v2GetRequestStateLengthDesc: "Get Request Data Length => {{outputVar}}",
        v2IfAdvanced: "If",
        v2IfAdvancedDesc: "If {{source}} {{condition}} {{target}}",
        v2QuickSearchChat: "Quick Search Chat",
        v2QuickSearchChatDesc: "Quick search {{value}} in chat with {{condition}} condition in {{depth}} depth => {{outputVar}}",
        v2StopPromptSending: "Stop Prompt Sending",
        v2StopPromptSendingDesc: "Stop Prompt Sending",
        v2Tokenize: "Tokenize",
        v2TokenizeDesc: "Tokenize {{value}} => {{outputVar}}",
        v2GetAllLorebooks: "Get All Lorebooks",
        v2GetAllLorebooksDesc: "Get all lorebook prompts as array => {{outputVar}}",
        v2GetLorebookByName: "Get Lorebook Indices by Name",
        v2GetLorebookByNameDesc: "Get lorebook indices array by name {{name}} => {{outputVar}}",
        v2GetLorebookByIndex: "Get Lorebook",
        v2GetLorebookByIndexDesc: "Get lorebook prompt at index {{index}} => {{outputVar}}",
        v2CreateLorebook: "Create Lorebook",
        v2CreateLorebookDesc: "Create lorebook with name {{name}}, key {{key}}, content {{content}}",
        v2ModifyLorebookByIndex: "Modify Lorebook",
        v2ModifyLorebookByIndexDesc: "Modify lorebook at index {{index}} with name {{name}}, key {{key}}, content {{content}}",
        v2DeleteLorebookByIndex: "Delete Lorebook",
        v2DeleteLorebookByIndexDesc: "Delete lorebook at index {{index}}",
        v2GetLorebookCountNew: "Get Lorebook Count",
        v2GetLorebookCountNewDesc: "Get total lorebook count => {{outputVar}}",
        v2SetLorebookAlwaysActive: "Set Lorebook Always Active",
        v2SetLorebookAlwaysActiveDesc: "Set lorebook at index {{index}} always active to {{value}}",
        v2Calculate: "Calculate",
        v2CalculateDesc: "Calculate {{expression}} => {{outputVar}}",
        v2ReplaceString: "Replace String",
        v2ReplaceStringDesc: "Replace {{source}} with regex {{regex}} to {{replacement}} => {{outputVar}}",
    },
    triggerInputLabels: {
        value: "Value",
        var: "Variable",
        varName: "Variable Name",
        outputVar: "Output Variable",
        name: "Name",
        index: "Index",
        source: "Source",
        target: "Target",
        condition: "Condition",
        operator: "Operator",
        role: "Role",
        location: "Location",
        prompt: "Prompt",
        model: "Model",
        start: "Start",
        end: "End",
        min: "Min",
        max: "Max",
        delimiter: "Delimiter",
        depth: "Depth",
        key: "Key",
        alertContent: "Alert Content",
        options: "Options",
        cmd: "Command",
        regex: "Regex",
        replacement: "Replacement",
        flags: "Flags",
        negPrompt: "Negative Prompt",
        resultFormat: "Result Format",
        activationKeys: "Activation Keys",
        insertOrder: "Insert Order",
        sysStart: "System Start",
        sysHistoryEnd: "System History End",
        sysPromptEnd: "System Prompt End",
        addElse: "Add Else",
        alwaysActive: "Always Active",
        trigger: "Trigger",
        triggerOn: "Trigger On",
        valueTypeDesc: "Use directly input value",
        varTypeDesc: "Use value stored in variable",
        conditionEqual: "Equal (=)",
        conditionNotEqual: "Not Equal (≠)",
        conditionGreater: "Greater (>)",
        conditionLess: "Less (<)",
        conditionGreaterEqual: "Greater or Equal (≥)",
        conditionLessEqual: "Less or Equal (≤)",
        conditionSimilar: "Similar (≒)",
        conditionContains: "Contains (∋)",
        conditionIn: "In (∈)",
        conditionNotContains: "Not Contains (∌)",
        conditionNotIn: "Not In (∉)",
        conditionTruthy: "Truthy (≡)",
        operatorSet: "Set (=)",
        operatorAdd: "Add (+=)",
        operatorSubtract: "Subtract (-=)",
        operatorMultiply: "Multiply (*=)",
        operatorDivide: "Divide (/=)",
        operatorModulo: "Modulo (%=)",
        searchLoose: "Loose Search",
        searchStrict: "Strict Search",
        searchRegex: "Regex Search",
        modelMain: "Main Model",
        modelSub: "Sub Model",
        roleUser: "User",
        roleChar: "Character",
        roleSystem: "System",
        roleAssistant: "Assistant",
        boolTrue: "True",
        boolFalse: "False",
        boolNull: "Null",
        helpVarName: "Enter the name of the variable",
        helpOutputVar: "Enter the variable name to store the result",
        helpIndex: "Array or message index number",
        helpRegex: "Enter regex pattern",
        helpFlags: "Regex flags",
        helpDelimiter: "Delimiter to split the string",
        helpActivationKeys: "Comma-separated activation keywords",
        helpInsertOrder: "Insert order",
        helpDepth: "Depth of messages to search",
        helpMinMax: "Min and max value range",
        helpSlot: "Use {{slot}} to keep unchanged",
        expression: "Expression",
    },
    playground: {
        playground: "Playground",
        inlayDeleteSelected: "Delete Selected",
        inlayDeselectAll: "Deselect All",
        inlayEmpty: "No saved inlay assets",
        inlayEmptyDesc: "Images, audio, and videos attached or generated in chats will appear here",
        inlayExplorer: "Inlay Assets Explorer",
        inlayImageGallery: "Inlay Image Gallery",
        inlayImageGalleryEmptyDesc: "Images attached or generated in chats will appear here",
        inlayImageList: "Image List",
        inlaySelectAll: "Select All",
        inlayDeleteConfirm: "Are you sure you want to delete {name}?",
        inlayDeleteMultipleConfirm: "Are you sure you want to delete the selected {count} assets?",
        inlayTotalAssets: "Total {count} assets",
        inlayDelete: "Delete",
        inlayLoadingMore: "Loading...",
        inlayCreatedAt: "Created:",
        inlayUpdatedAt: "Updated:",
        inlaySort: "Sort",
        inlaySortUpdatedDesc: "Updated ↓",
        inlaySortUpdatedAsc: "Updated ↑",
        inlaySortCreatedDesc: "Created ↓",
        inlaySortCreatedAsc: "Created ↑",
        inlayFilter: "Filter",
        inlayFilterAll: "All",
        inlayFilterMetaMissing: "Meta Missing",
        inlayFilterOrphanCharacter: "Orphan Character",
        inlayFilterOrphanChat: "Orphan Chat",
        inlayOriginalLoadNeeded: "Original Load Needed",
        inlayAudioAsset: "Audio Asset",
        inlayVideoAsset: "Video Asset",
        inlaySignatureAsset: "Signature Asset",
        inlayInfo: "Info",
        inlayManualMapping: "Manual Mapping",
        inlayActions: "Actions",
        inlayLoadingOriginal: "Loading original image...",
        inlaySave: "Save",
        inlaySaved: "Saved!",
        inlayFilterOrphanMessage: "Not in Messages",
        inlayScanMessages: "Scan Messages",
        inlayScanning: "Scanning...",
        inlayScanDone: "Scanned {count} messages",
    },
    confirm: "Confirm",
    yes: "Yes",
    no: "No",
    goback: "Go Back",
    botSettings: "Bot Settings",
    model: "Model",
    apiKey: "API Key",
    providerURL: "Request URL",
    providerJSON: "Request Body JSON",
    mainPrompt: "Main Prompt",
    jailbreakPrompt: "Jailbreak Prompt",
    globalNote: "Global Note",
    autoSuggest: "Auto Suggest",
    tokens: "Tokens",
    maxContextSize: "Max Context Size",
    maxResponseSize: "Max Response Size",
    temperature: "Temperature",
    frequencyPenalty: "Frequency Penalty",
    presensePenalty: "Presense Penalty",
    advancedSettings: "Advanced Settings",
    advancedSettingsWarn: "Warn: If you don't know what the option does, don't change it!",
    formatingOrder: "Formating Order",
    authorNote: "Author's Note",
    firstMessage: "First Message",
    description: "Description",
    note: "Note",
    jailbreakToggle: "Toggle Jailbreak",
    charIcon: "Character Icon",
    characterDisplay: "Character Display",
    viewScreen: "Additional Character Screen",
    none: "None",
    emotionImage: "Emotion Images",
    noImages: "No Images",
    noBias: "No Bias",
    image: "Image",
    name: "Name",
    characterName: "Character Name",
    characterInfo: "Character Info",
    folderName: "Folder Name",
    folderRemoveConfirm: "This folder contains lorebooks. Are you sure you want to delete it and all its contents?",
    emotion: "Emotion Name",
    value: "Value",
    reroll: "Regenerate",
    hideMessagePageCount: "Hide Message Page Counter",
    deleteRerollMessage: "Delete Regenerated Message",
    deleteRerollMessageConfirm: "Delete the currently selected regenerated message?",
    rerollConfirm: "Generate a new message and add it to the list?",
    noSwipesRerollConfirm: "There are no additional regenerated messages. Generate a new message and add it to the list?",
    chatList: "Chat List",
    removeChat: "Remove this message?",
    loreBook: "Lorebook",
    character: "Character",
    Chat: "Chat",
    globalLoreInfo: "Character Lorebook applys to all chats in the character.",
    group: "Group",
    localLoreInfo: "Chat Lorebook only applies to the current chat.",
    removeConfirm: "Do you really want to remove: ",
    removeConfirm2: "Do you REALLY want to remove: ",
    exportConfirm: "Do you want to export this?",
    insertOrder: "Insertion Order",
    activationKeys: "Activation keys",
    activationKeysInfo: "Comma seperated",
    prompt: "Prompt",
    loreBookDepth: "Lorebook Search Depth",
    loreBookToken: "Lorebook Max Tokens",
    chatLoadInitialPages: "Initial Chat Load Count",
    chatLoadAdditionalPages: "Additional Chat Load Count",
    removeCharacter: "Remove Character",
    exportCharacter: "Export Character",
    characterPackage: "Character Package",
    characterPackageExport: "Export Package",
    convertToModule: "Convert to Module",
    convertToCharacter: "Convert to Character",
    successfullyConverted: "Successfully converted.",
    characterPackageImport: "Import Character Package (zip)",
    characterPackageCharacter: "Character",
    characterPackageChats: "Chats",
    characterPackagePersona: "Persona",
    characterPackageInlays: "Inlay Images",
    characterPackageNone: "None",
    characterPackageChatCount: "",
    characterPackageInlayCount: "",
    characterPackageExportSuccess: "Character package exported successfully.",
    characterPackageImportSuccess: "Character package imported successfully.",
    characterPackageImportSummary: "Package Contents",
    characterPackageInvalidZip: "Invalid character package file.",
    characterPackageProgressCharacter: "Building character...",
    characterPackageProgressChats: "Writing chats...",
    characterPackageProgressPersona: "Writing personas...",
    characterPackageProgressInlays: "Writing inlays",
    characterPackageProgressFinalizing: "Finalizing...",
    characterPackageProgressReading: "Reading package...",
    characterPackageProgressImportChar: "Importing character...",
    characterPackageProgressImportPersona: "Importing personas...",
    characterPackageProgressImportChats: "Importing chats...",
    characterPackageProgressImportInlays: "Importing inlays",
    characterPackageEmpty: "empty shell",
    characterPackageEmptyWarning: "Character data is empty. Import anyway?",
    characterPackageNameMismatch: "Character names do not match. Import anyway?",
    characterPackageImportToChar: "Import Package to Character",
    characterPackageLicenseWarning: "Character export is restricted by license policy",
    characterPackageCheckCount: "Check",
    userSetting: "User Settings",
    username: "Your Name",
    userIcon: "Your Icon",
    successExport: "Successfuly exported and downloaded to your download directory",
    successImport: "Successfuly imported",
    moduleCreated: "Module created.",
    moduleUpdated: "Module updated.",
    moduleDeleted: "Module deleted.",
    importedCharacter: "Imported Character",
    alwaysActive: "Always Active",
    additionalPrompt: "Additional Prompt",
    descriptionPrefix: "Description Prefix",
    forceReplaceUrl: "Reverse Proxy",
    emotionWarn: "Auxiliary model is used.",
    plugin: "Plugin",
    language: "Language",
    UiLanguage: "UI Language",
    createfromScratch: "Create from Scratch",
    importCharacter: "Import Character",
    translator: "Translator",
    disabled: "Disabled",
    noPluginSelected: "Model selected as plugin, but no plugin selected.",
    text: "Text",
    UISize: "Chat Text Size",
    newVersion: "Update found, do you want to install?",
    updateAvailable: "v{{version}} update available",
    updateRequired: "v{{version}} required update available",
    updateOutdated: "v{{version}} — your version is too old",
    statsUsersToday: "{{count}} users today",
    statsYesterday: "{{count}} yesterday",
    statsVisitsToday: "{{count}} visits today",
    updatePopupTitle: "Update Available",
    updatePopupTitleRequired: "Required Update",
    updatePopupTitleOutdated: "Version Too Old",
    updatePopupDesc: "A new version <b>v{{latest}}</b> is available. (current: v{{current}})",
    updatePopupViewRelease: "View Release",
    updatePopupLater: "Later",
    selfUpdateNow: "Update Now",
    selfUpdateInProgress: "Updating...",
    selfUpdateDone: "Update Complete",
    selfUpdateFailed: "Update Failed",
    selfUpdateReloadHint: "Please reload the page to use the new version.",
    selfUpdateReload: "Reload",
    close: "Close",
    remindLaterQuestion: "When should I remind you?",
    remindIgnore: "Ignore",
    remindLater1Day: "Remind in 1 day",
    remindLater3Days: "Remind in 3 days",
    remindLater5Days: "Remind in 5 days",
    remindLater1Week: "Remind in 1 week",
    display: "Display",
    useCustomBackground: "Custom Background",
    translateInput: "Translate Input",
    autoTranslation: "Auto Translation",
    fullscreen: "Fullscreen (Not recommended)",
    playMessage: "Play Message Audio",
    iconSize: "Icon Size",
    single: "Single",
    multiple: "Multiple",
    useCharLorebook: "Use Lores in Characters",
    selectChar: "Select Character",
    askLoadFirstMsg: "Shall we load the first message?",
    theme: "Theme",
    editOrder: "Edit Order",
    submodel: "Auxiliary Model",
    timeOutinSec: "Timeout (in seconds)",
    emotionPrompt: "Emotion Prompt",
    singleView: "Single View",
    SpacedView: "Multiple Character View",
    emphasizedView: "Double Character View",
    pluginWarn: "Installing malicious plugins can cause problems.",
    pluginConfirm: "Do you really want to import this plugin? Only import plugins from trusted sources.",
    pluginContainsExternalMedia: "This plugin contains external media.",
    pluginContainsExternalJS: "This plugin contains external Javascript.",
    waifuWidth: "Waifu Chat Width",
    files: "Files",
    backupConfirm: "Do you really want to save backup?",
    backupLoadConfirm: "Do you really want to load backup? All datas will be lost!",
    backupLoadConfirm2: "Do you really, really want to load backup? All datas will be lost!",
    others: "Others",
    sectionInterface: "Interface",
    sectionHomeList: "Home & Chat List",
    sectionChatView: "Chat View",
    sectionBubble: "Message Bubble",
    sectionQuotes: "Quotes",
    sectionAdvanced: "Advanced",
    accTabEditing: "Editing",
    accTabScroll: "Scroll",
    accTabSidebar: "Sidebar",
    presets: "Presets",
    themePresets: "Theme Presets",
    imageGeneration: "Image Generation",
    provider: "Provider",
    key: "Key",
    noData: "No Data",
    currentImageGeneration: "Current Image Generation Data",
    promptPreprocess: "Use Prompt Preprocess",
    SwipeRegenerate: "Use Swipe for Regeneration",
    removeMessageOnly: "Remove this message only",
    removeMessageAndAfter: "Remove this and following messages ({})",
    messageRemoved: "Message removed",
    messagesRemoved: "{} messages removed",
    confirmReroll: "Confirm on Message Regeneration",
    textColor: "Text Color",
    classicRisu: "Classic Risu",
    highcontrast: "High-Contrast",
    requestretrys: "Request Retrys when Fail",
    utilityBot: "Utility Bot",
    waifuWidth2: "Waifu Character Size",
    nodeOnlyStandardChatWidth: "Chat Width",
    chatWidthStandard: "Standard",
    chatWidthWide: "Wide",
    chatWidthFull: "No Limit",
    customCSSWarning: "PocketRisu's UI structure (HTML/CSS) differs from upstream RisuAI, so existing custom CSS may break the layout or behave unexpectedly. Use only when you know what you are overriding.",
    customHTMLWarning: "PocketRisu's UI structure (HTML/CSS) differs from upstream RisuAI, so existing custom Chat HTML may not render correctly. Use only when you know what you are overriding.",
    sayNothing: "Input 'say nothing' when no string inputed",
    regexScript: "Regex Script",
    type: "Type",
    editInput: "Modify Input",
    editOutput: "Modify Output",
    editProcess: "Modify Request Data",
    loadLatest: "Load Latest Backup",
    loadOthers: "Load Other Backups",
    exampleMessage: "Example Message",
    creatorNotes: "Creator's Comment",
    systemPrompt: "System Prompt",
    characterNotes: "Character Notes",
    personality: "Personality",
    scenario: "Scenario",
    alternateGreetings: "Alternate Greetings",
    unrecommended: "Not Recommended",
    chatNotes: "Chat Notes",
    showUnrecommended: "Show Unrecommended Settings",
    streamingDisplayOptimizationMode: "Streaming Display Optimization",
    streamingDisplayOptimizationOff: "Off (every token)",
    streamingDisplayOptimizationOffDesc: "Redraw and run scripts on every incoming token",
    streamingDisplayOptimizationBalanced: "Update every 0.1s",
    streamingDisplayOptimizationBalancedDesc: "Batch redraws into 0.1s intervals to lower the load",
    streamingDisplayOptimizationStrong: "Apply after finish",
    streamingDisplayOptimizationStrongDesc: "Show raw text while streaming, then run scripts once at the end",
    allowV2Plugin: "Allow Deprecated V2.0 Plugins",
    allowV21Plugin: "Allow Installing Deprecated V2.1 Plugins",
    altGreet: "Alternative First Messages",
    scripts: "Scripts",
    settings: "Settings",
    selective: "Selective",
    SecondaryKeys: "Secondary keys",
    useGlobalSettings: "Use Global Settings",
    recursiveScanning: "Recursive Scanning",
    creator: "Creator",
    CharVersion: "Character Version",
    Speech: "Speech",
    useExperimental: "Able Experimental Features",
    showMemoryLimit: "Show Memory Limit",
    showFirstMessagePages: "Show First Message Pages",
    roundIcons: "Round Icons",
    streaming: "Streaming",
    chatBot: "Chat Bot",
    modelPresetMenu: "Model Preset",
    promptPresetMenu: "Prompt",
    botSettingsLegacyTitle: "[Chat Bot] is a legacy feature",
    botSettingsLegacyDesc: "Model updates may be delayed and new features may not apply here. Use [Model Preset] for up-to-date models and features.",
    botSettingsPresetMovedDesc: "Presets have moved to the [Prompt] menu.",
    botSettingsParamScopeDesc: "Parameters on this page only apply to the model selected in [Chat Bot]. If you use a Model Preset, edit parameters inside that preset.",
    botSettingsCustomFlagsScopeDesc: "Custom flags only apply to legacy models. Model Presets apply capabilities automatically, based on the model profile.",
    currentThemePreset: "Current Theme Preset",
    currentPromptPreset: "Current Prompt Preset",
    presetDuplicate: "Duplicate",
    presetExport: "Export",
    presetImport: "Import",
    presetNew: "New preset",
    presetManage: "Manage presets",
    moduleManage: "Manage modules",
    pluginImport: "Import plugin",
    pluginDevTools: "Developer tools",
    presetDelete: "Delete",
    presetDuplicated: "Preset duplicated",
    presetExported: "Preset exported",
    presetImported: "Preset imported",
    presetDeleted: "Preset deleted",
    presetDeleteConfirm: "Delete this preset?",
    iconRemove: "Remove Icon",
    otherBots: "Other Bots",
    user: "User",
    additionalAssets: "Additional Assets",
    viewInAssetViewer: "View in Asset Viewer",
    editDisplay: "Modify Display",
    textBackgrounds: "Custom Text Screen Color",
    textBorder: "Text Outlines",
    textScreenRound: "Round Text Screen",
    textScreenBorder: "Text Screen Borders",
    ttsReadOnlyQuoted: "Read Only Quoted",
    ttsStop: "Stop TTS",
    replaceGlobalNote: "Global Note Replacement",
    charLoreBook: "Character Lorebook",
    globalLoreBook: "Global Lorebook",
    globalRegexScript: "Global Regex",
    accessibility: "Accessibility",
    sendWithEnter: "Send with Enter Key",
    sendKeyPC: "Send Key (PC)",
    sendKeyMobile: "Send Key (Mobile)",
    chatInputExpandTitle: "Message input",
    resendLastMessage: "Resend the last message",
    enterMessagePlaceholder: "Enter a message...",
    enterMessageToPersona: (name: string) => `Message ${name}...`,
    sendKeyEnter: "Enter (Shift+Enter for newline)",
    sendKeyCtrlEnter: "Ctrl+Enter (Enter for newline)",
    sendKeyShiftEnter: "Shift+Enter (Enter for newline)",
    sendKeyButton: "Send button only (Enter for newline)",
    fixedChatTextarea: "Fix chat input to bottom",
    clickToEdit: "Click Text to Edit",
    enableBlockPartialEdit: "Enable Block Partial Edit (Hover to edit individual blocks)",
    enableDragPartialEdit: "Enable Drag Partial Edit (Select text to edit)",
    setNodePassword: "Set your password to security",
    inputNodePassword: "Input your password. if you can't remember, remove save/__password.txt in your server files and restart the server.",
    simple: "Simple",
    advanced: "Advanced",
    askReRollAutoSuggestions: "Re-Roll Auto Suggestions",
    creatingSuggestions: "Creating Suggestions...",
    active: "Active",
    loreRandomActivation: "Use Probability Condition",
    activationProbability: "Probability",
    hub: "RisuRealm",
    tags: "Tags",
    backgroundHTML: "Background Embedding",
    copied: "Copied",
    useChatCopy: "Use Chat Message Copy",
    useChatSticker: "Use Chat Sticker",
    useAdditionalAssetsPreview: "Use Additional Assets Preview",
    autoTranslateInput: "Auto Translate Input",
    enterMessageForTranslateToEnglish: "Enter Message for Translate to English",
    recent: "Recent",
    downloads: "Downloads",
    trending: "Trending",
    imageCompression: "Image Compression",
    inlayImageLossless: "Save Inlay Images as Lossless",
    inlayImagePriority: "Prioritize Inlay Image Rendering",
    inlayCompressAll: "Compress All Inlay Images",
    inlayCompressing: "Compressing...",
    inlayCompressConfirm: "All inlay images will be compressed to WebP. This cannot be undone. Continue?",
    inlayCompressDone: "Compression complete",
    inlayCompressCount: " images compressed",
    saved: "saved",
    notLoggedIn: "Not Logged in to Risu Account",
    SaveDataInAccount: "Save Data in Account",
    dataSavingInAccount: "Saving Data in Account",
    logout: "Logout",
    loadDataFromAccount: "Load Data from Account",
    saveCurrentDataToAccount: "Save Current Data to Account",
    chatAssumed: "",
    proxyAPIKey: "Key/Password",
    proxyRequestModel: "Request Model",
    officialWiki: "Official Wiki",
    officialWikiDesc: "Official Wiki for PocketRisu. feel free to see.",
    officialDiscord: "Official Discord",
    officialDiscordDesc: "Official Discord to talk about PocketRisu",
    persona: "Persona",
    personaSearch: "Search by name or note",
    personaManage: "Manage personas",
    memoryPresetDefault: "Default preset",
    memoryBindingLabel: "Long-term Memory Binding",
    memoryPresetOff: "Off",
    memoryPresetInherit: "Default",
    memoryPresetSetDefault: "Set as default",
    memoryPresetCreate: "New preset",
    memoryPresetSearch: "Search by preset name",
    memoryPresetMethod: "Method",
    memoryPresetName: "Preset name",
    memoryPresetManage: "Manage long-term memory",
    memoryPresetLastOne: "There must be at least one preset.",
    memoryPresetBound: "Long-term memory preset changed.",
    folderUncategorized: "Uncategorized",
    folderNew: "New folder",
    folderMoveTo: "Move to folder",
    folderDeleteKeepItems: "Delete this folder? Items in it will become uncategorized.",
    moveUp: "Move up",
    moveDown: "Move down",
    icon: "Icon",
    account: "Account",
    remove: "Remove",
    able: "Able",
    assetWidth: "Asset Images Max Width",
    animationSpeed: "Animation Speed",
    screenshot: "Screenshot",
    screenshotSaved: "Screenshot Saved",
    createBotwithAI: "Create Bot from AI",
    changeFolderName: "Input the new folder name (blank to cancel)",
    cancel: "Cancel",
    renameFolder: "Rename Folder",
    changeFolderColor: "Change Folder Color",
    changeFolderImage: "Change Folder Image",
    fullWordMatching: "Full Word Matching",
    botSettingAtStart: "Bot Menu when Launch",
    triggerStart: "On chat Send",
    triggerInput: "On user's output",
    triggerOutput: "On character's output",
    triggerManual: "Manual trigger only",
    triggerCondVar: "If Variable",
    triggerCondExists: "If Text Exists on Chat",
    triggerScript: "Trigger Script",
    triggerMatchRegex: "Match with Regex",
    triggerMatchLoose: "Match Loosely",
    triggerMatchStrict: "Match Strictly",
    searchDepth: "Search Depth",
    equal: "Equal to",
    notEqual: "Not Equal to",
    greater: "Greater than",
    less: "Less than",
    greaterEqual: "Greater or Equal to",
    lessEqual: "Less or Equal to",
    triggerEffSysPrompt: "Add System Prompt",
    triggerEffSetVar: "Modify Variable",
    triggerEffImperson: "Send Chat",
    triggerEffCommand: "Run Command",
    triggerEffRunTrigger: "Run Trigger",
    triggerEffStop: "Stop Sending Prompt",
    triggerEffCall: "Call Trigger",
    varableName: "Variable Name",
    role: "Role",
    location: "Location",
    promptstart: "Start of Prompt",
    promptend: "End of Prompt",
    historyend: "End of History",
    always: "Always",
    noEffect: "No Effect",
    invaildTriggerEffect: "This effect doesn't works for this trigger type.",
    operator: "Operator",
    TriggerSetToVar: "Set to Variable",
    TriggerAddToVar: "Add to Variable",
    TriggerSubToVar: "Subtract from Variable",
    TriggerMulToVar: "Multiply to Variable",
    TriggerDivToVar: "Divide from Variable",
    isNull: "is not set",
    ifChatIndex: "If chat index",
    ifRandom: "If random",
    ifValue: "If Value",
    hideRealm: "Start RisuRealm Collapsed",
    hideAllImages: "Hide All Images",
    popularityLevel: "{} Popularity",
    colorScheme: "Color Scheme",
    colorSchemeDefault: "Default",
    showLegacyColorSchemes: "Show legacy palettes",
    rangeStart: "Range Start",
    rangeEnd: "Range End",
    untilChatEnd: "Until Chat End",
    usePromptTemplate: "Use Prompt Template",
    specialType: "Special Type",
    noSpecialType: "No Special Type",
    forceProxyAsOpenAI: "Force Proxy Format as OpenAI",
    promptTemplate: "Prompt Template",
    customInnerFormat: "Custom Inner Format",
    innerFormat: "Inner Format",
    HypaMemory: "HypaMemory",
    ToggleHypaMemory: "Toggle HypaMemory",
    resetPromptTemplateConfirm: "Do you really want to reset prompt template?",
    emotionMethod: "Emotion Method",
    continueResponse: "Continue Response",
    showMenuChatList: "Show Menu Chat List",
    translatorLanguage: "Translator Language",
    translatorType: "Translator Type",
    htmlTranslation: "HTML Translate",
    deeplKey: "deepL API Key",
    deeplFreeKey: "deepL Free API Key",
    deeplXUrl: "deepLX URL",
    deeplXToken: "deepLX Token",
    exportPersona: "Export Persona",
    importPersona: "Import Persona",
    export: "Export",
    import: "Import",
    useNamePrefix: "Use Name Prefix",
    textAdventureNAI: "Run as Text Adventure",
    appendNameNAI: "Append Name on NAI",
    customStopWords: "Custom Stop Words",
    defaultPrompt: "Default Prompt",
    additionalText: "Additional Description",
    seed: "Seed",
    charjs: "CharacterJS",
    depthPrompt: "Depth Prompt",
    largePortrait: "Portrait",
    reverseProxyOobaMode: "Ooba Mode",
    exactTokens: "Exact Tokens",
    fixedTokens: "Approximate Tokens",
    inlayViewScreen: "Inlay Screen",
    imgGenPrompt: "Image Generation Prompt",
    imgGenNegatives: "Image Generation Negative Prompt",
    imgGenInstructions: "Image Generation Instructions",
    usePlainFetchWarn: "Please disable this option when using NovelAI, as it can cause CORS errors when using NovelAI.",
    translationPrompt: "Translation Prompt",
    translationResponseSize: "Translation Response Size",
    webdeeplwarn: "This option is not recommended for use with web version, as it can cause CORS errors.",
    saveBackupLocal: "Save Backup Locally",
    saveBackupForUpstream: "Save Backup for Original RisuAI",
    saveBackupForUpstreamConfirm: "This backup is intended for moving your data to the original RisuAI (web/Tauri). Inlay images are excluded because their entry names use a layout that the original RisuAI cannot import. Other data (database, character assets, cold storage) is included.\n\nFor moving data between PocketRisu installations, use the regular local backup instead.\n\nProceed?",
    loadBackupLocal: "Load Backup Locally",
    topP: "Top P",
    genTimes: "Generation Choices",
    cot: "Chain of Thoughts",
    forcePlainFetch: "Force Plain Fetch",
    autoFillRequestURL: "Autofill Request URL",
    newOAIHandle: "New OpenAI Handling",
    inlayImage: "Inlay Image Feature",
    nativeAutomark: "Experimental Native Automark",
    assistantPrefill: "Assistant Prefill",
    postEndInnerFormat: "Post End",
    sendChatAsSystem: "Send Chat as System",
    sendName: "Send Name on Non-group Chat",
    utilOverride: "Utility Override",
    template: "Template",
    chatAsOriginalOnSystem: "Send as original role",
    exportAsDataset: "Export Save as Dataset",
    editTranslationDisplay: "Edit Translation Display",
    selectModel: "Select Model",
    autoRemoveThoughtTag: "Remove Thought Tag",
    customChainOfThought: "Custom Chain of Thoughts",
    maxThoughtTagDepth: "Max Thought Tag Depth",
    openRouterFallback: "Use Fallback",
    openRouterMiddleOut: "Use Middle Out",
    openRouterProviderOrder: "Provider Preference Order",
    openRouterProviderOnly: "Allowed Providers",
    openRouterProviderIgnore: "Ignored Providers",
    openRouterSearchModel: "Search models...",
    openRouterSortByName: "Name",
    openRouterSortByPrice: "Price",
    openRouterSortByProvider: "Provider",
    openRouterSortAsc: "Asc",
    openRouterSortDesc: "Desc",
    geminiApiKey: "Gemini API Key",
    memoryLimitThickness: "Memory Limit Thickness",
    inputCardPassword: "Input Card Password",
    ccv2Desc: "Character Card V2 is a format widely used in chatbot programs.",
    ccv3Desc: "Character Card V3 is a next generation format that is used in chatbot programs.",
    rccDesc: "Risu Refined Character Card is a format with additional features like password, integrity check and etc.",
    password: "Password",
    license: "License",
    licenseDesc: "You can choose license for the downloaders to limit the usages of your card's prompt.",
    passwordDesc: "You can set a password to protect your card from unauthorized access.",
    largePersonaPortrait: "Persona Portrait",
    module: "Module",
    modules: "Modules",
    noModules: "No modules has been installed.",
    createModule: "Create Module",
    basicInfo: "Basic Info",
    moduleContent: "Module Content",
    confirmRemoveModuleFeature: "Do you really want to remove this feature? This action cannot be undone.",
    editModule: "Edit Module",
    importModule: "Import Module",
    download: "Download",
    edit: "Edit",
    enableGlobal: "Enable Globally",
    chatModulesInfo: "Enable or disable modules for this chat or for this character. The speech bubble button is the chat scope, the person button is the character scope. A module with a globe is enabled globally and applies to every chat; change that in Settings > Modules.",
    moduleScopeChat: "Use in this chat",
    moduleScopeCharacter: "Use for this character",
    moduleScopeGlobal: "Enabled globally. Change in Settings > Modules",
    sideMenuRerollButton: "Side Menu Reroll Button",
    persistentStorage: "Persistent Storage",
    persistentStorageSuccess: "Storage is successfully persisted",
    persistentStorageFail: "Storage is not persisted. Did you deny the request?, or is the browser not supported?",
    persistentStorageRecommended: "Persistent Storage Recommended",
    unsupportedFileType: "Unsupported file type",
    persistentStorageDesc: "Your browser supports persistent storage. this is recommended for better performance and user experience.",
    enable: "Enable",
    postFile: "Post File",
    requestInfoInsideChat: "Show Request Info Inside Chat",
    inputTokens: "Input Tokens",
    outputTokens: "Output Tokens",
    tokenWarning: "Token caculation can be inaccurate. it is recommended to use it as a reference.",
    log: "Log",
    popularityLevelDesc: "Popularity increases with downloads, etc. to estimate, 3.7 popularity is about 1 downloads.",
    additionalParams: "Additional Parameters",
    additionalParamsHelp: "One per line. Supports `key=value`, `key=json::{...}`, `header::Name=value`, `key={{none}}`.",
    tokenizerOverride: "Tokenizer Override",
    tokenizerOverrideHelp: "Used for token counting. Leave Auto to use the profile recommendation.",
    tokenizerAuto: "Auto",
    heightMode: "Height Mode",
    useAdvancedEditor: "Use Advanced Editor",
    noWaitForTranslate: "No Wait for Translate",
    antiClaudeOverload: "Anti-Claude Overload",
    activeTabChange: "Current tab is inactivated since other tab is active. to activate this tab, click OK",
    sessionHandoffReload: "Refreshed to the latest state because another device was in use.",
    addCharacter: "Add Character",
    importFromRealm: "Choose from RisuRealm",
    importFromRealmDesc: "Choose over 1000 characters in RisuRealm",
    random: "Random",
    metaData: "Meta Data",
    autoContinueMinTokens: "Target Tokens (Auto Continue)",
    autoContinueChat: "Anti-Incomplete Response (Auto Continue)",
    removeIncompleteResponse: "Remove Incomplete Sentences",
    tokenizer: "Tokenizer",
    chatFormating: "Chat Formating",
    useInstructPrompt: "Use Instruction Prompt",
    textAreaSize: "Input box size",
    textAreaTextSize: "Input text size",
    sideBarSize: "Sidebar Size",
    embedding: "Embedding",
    syntax: "Syntax",
    run: "Run",
    noMessage: "Type something to start the chat.",
    combineTranslation: "Combine Translation",
    dynamicAssets: "Dynamic Assets",
    dynamicAssetsEditDisplay: "Use Dynamic Assets in Display",
    longTermMemory: "Long Term Memory",
    grid: "Grid",
    list: "List",
    trash: "Trash",
    trashDesc: "Deleted characters are moved to trash. you can restore or delete them permanently. deleted characters are automatically purged after 3 days.",
    shareExport: "Share/Export",
    risupresetDesc: "Risupreset format is a format specifically designed for PocketRisu presets.",
    risuMDesc: "RisuM format is a format that is specifically designed for PocketRisu modules.",
    jsonDesc: "JSON format is a format that is easy to read and write for both humans and machines.",
    nickname: "Nickname",
    useRegexLorebook: "Use Regex",
    customPromptTemplateToggle: "Custom Toggles",
    defaultVariables: "Default Variables",
    lowLevelAccess: "Low Level Access",
    resultStoredVar: "Variable to Store Result",
    triggerEffRunLLM: "Run Main Model",
    triggerEffectSendAI: "Resend AI",
    triggerEffCheckSim: "Check Similarity",
    triggerEffShowAlert: "Show Alert",
    normal: "Normal",
    error: "Error",
    input: "Input",
    select: "Select",
    options: "Options",
    alertContent: "Alert Content",
    lowLevelAccessConfirm:
        "This content uses Low Level Access. which means this content can access the AI model and your storage directly. do you really want to import this content?",
    triggerLowLevelOnly: "This trigger only works with Low Level Access. to enable this trigger, enable Low Level Access in advanced settings in the character or module.",
    truthy: "Truthy",
    extractRegex: "Extract Text with Regex",
    runImgGen: "Run Image Generation",
    cutChat: "Cut Chat",
    modifyChat: "Modify Chat",
    regex: "Regex",
    flags: "Flags",
    resultFormat: "Result Format",
    negPrompt: "Negative Prompt",
    start: "Start",
    end: "End",
    index: "Index",
    search: "Search",
    goCharacterOnImport: "Go to Character on Realm Import",
    format: "Format",
    v2Warning: "Warning: V2 card is no longer supported. it may not contain all the data.",
    applyModule: "Apply Module",
    successApplyModule: "Module is successfully applied",
    font: "Font",
    lineHeight: "Line Height",
    loadAutoServerBackup: "Load Auto Server Backup",
    notCharxWarn: "This character uses multiple assets. it is recommended to export this character as a CharX format for better compatibility.",
    noPlugins: "No Plugins Installed",
    legacyTranslation: "Legacy Translation",
    clipboardSuccess: "Copied to Clipboard",
    translateContent: "Translate Content",
    doNotTranslate: "Do Not Translate",
    includePersonaName: "Include Persona Name",
    hidePersonaName: "Hide Persona Name",
    triggerSwitchWarn: "If you change the trigger type, current triggers will be lost. do you want to continue?",
    codeMode: "Code",
    blockMode: "Block",
    helpBlock: "Help",
    hideChatIcon: "Hide Icon UI",
    loadInternalBackup: "Load Internal Backup",
    createCopy: "Create a Copy",
    copyChatConfirm: "Create a copy of: ",
    copyChatSuccess: "Chat copied",
    bindPersona: "Bind Persona",
    chatOptions: "Chat Options",
    doYouWantToBindCurrentPersona: "Do you want to bind the current persona to this chat?",
    doYouWantToUnbindCurrentPersona: "Do you want to unbind the persona from this chat?",
    personaBindingLabel: "Persona Binding",
    personaBindedSuccess: "Persona is successfully binded",
    personaUnbindedSuccess: "Persona is successfully unbinded",
    personaBindChange: "Change Persona",
    personaBindUnbind: "Unbind",
    personaBindCurrent: "Bind Current Persona",
    personaSelectOther: "Select Other Persona",
    promptBindingLabel: "Prompt Binding",
    promptPresetParamsUse: "Use Prompt Parameters",
    promptPresetParamScopeDesc: "These parameters are stored in this prompt preset. In classic model mode they always apply. With a Model Preset, sampling parameters apply only to chats where \"Use Prompt Parameters\" is enabled in the sidebar's Prompt Binding. Capacity settings (Max Context/Response) are properties of the model, so the model preset always decides them.",
    promptBindedSuccess: "Prompt preset is successfully binded",
    promptUnbindedSuccess: "Prompt preset is successfully unbinded",
    promptBindChange: "Change Prompt Preset",
    promptBindUnbind: "Unbind",
    promptBindCurrent: "Bind Current Prompt",
    presetSelectOther: "Select Other Prompt Preset",
    promptPresets: "Prompt Presets",
    presetEdit: "Edit",
    modelPresets: "Model Presets",
    modelPresetEmpty: "No model presets registered",
    modelPresetCreate: "Create new model preset",
    basicSettings: "Basic Settings",
    backToList: "Back to list",
    selectProfile: "Select Profile",
    searchProfiles: "Search profiles",
    noProfileMatch: "No matching profile",
    modelPresetCreated: "Model preset created",
    profileStatusCurrent: "Current",
    profileStatusOutdated: "Outdated",
    profileStatusDeprecated: "Deprecated",
    profileTabOfficial: "Official",
    profileTabCustom: "Custom",
    profileImport: "Import profile",
    profileExport: "Export",
    profileDelete: "Delete",
    profileExportNoBase: "Cannot export: base provider not found.",
    profileImportParseError: "Failed to parse JSON.",
    profileImportInvalid: "Invalid profile fragment:",
    profileOverwriteConfirm: "A custom profile with the same id already exists. Overwrite?",
    profileImported: "Profile imported.",
    customProfileEmpty: "No custom profiles. Import one to add.",
    profileReplace: "Replace profile",
    profileReplaced: "Profile replaced.",
    profileDataIncomplete: "This profile's data is incomplete. Reopen the Model Preset menu to refresh the registry, then try again.",
    profileUpdateAvailable: "Update available",
    profileSourceMissing: "Source profile not found",
    profileSectionTitle: "Profile",
    profileUpdatedAtLabel: "Current version",
    profileLatestVersionLabel: "Latest",
    profileUpdateConfirm: "Update to this profile?",
    profileReplaceWarn: "Settings not defined by this profile will be lost. Continue?",
    profileUpdateLossWarn: "Some settings may be lost. Continue?",
    registryNoticeBanner: "{n} model profiles updated",
    registryNoticeMore: "Details",
    registryNoticeTitle: "Model profile updates",
    registryNoticeNewSection: "New models",
    registryNoticeUpdatedSection: "Updated models",
    registryNoticeDismiss: "Don't show this update again",
    registryNoticeConfirm: "OK",
    apiKeyManagerMenu: "Manage API keys",
    apiKeyManagerDesc: "Save API keys to reuse across multiple presets.",
    apiKeyAdd: "Add key",
    apiKeyName: "Name",
    apiKeyProvider: "Provider",
    apiKeyProviderUnset: "Unspecified",
    apiKeyValue: "API key",
    apiKeyPoolEmpty: "No saved keys.",
    apiKeyModePool: "Saved key",
    apiKeyModeDirect: "Direct input",
    apiKeySelectNone: "Not selected",
    apiKeyDeletedOption: "Deleted key",
    apiKeyShowAll: "Show all keys",
    apiKeySave: "Save this key",
    apiKeyFormSave: "Save",
    apiKeyNamePrompt: "Enter a name for this key",
    parameters: "Parameters",
    sizeAndSpeed: "Size and Speed",
    useLegacyGUI: "Use Legacy GUI",
    claudeCachingExperimental: "Claude Caching",
    openClose: "Open/Close",
    hideApiKeys: "Hide API Keys",
    unformatQuotes: "Disable Quote Formatting",
    enableDevTools: "Enable Dev Tools",
    selectFile: "Select File",
    namespace: "Namespace",
    moduleIntergration: "Module Integration",
    previewInfo: "This preview shows prompt before model-specific processing.",
    miscTools: "Misc Tools",
    promptConvertion: "Prompt Convertion",
    convertionStep1: "Select all file related to the prompt (Context, Instruct and Sampler JSON is supported)",
    customCSS: "Custom CSS",
    betaMobileGUI: "Mobile GUI (Not recommended)",
    enableScrollToActiveChar: "Enable Scroll to Active Character",
    menu: "Menu",
    jsonSchema: "JSON Schema",
    enableJsonSchema: "Enable Schema",
    strictJsonSchema: "Strict Schema",
    extractJson: "Extract JSON",
    reloadSession: "Newer version of save data is found. reloading the session...",
    fixMarkdownNewline: "Fix Markdown Newline",
    customQuotes: "Custom Quotes",
    leadingSingleQuote: "Leading Single Quote",
    leadingDoubleQuote: "Leading Double Quote",
    trailingSingleQuote: "Trailing Single Quote",
    trailingDoubleQuote: "Trailing Double Quote",
    translatorNote: "Translator's Note",
    formatGroupInSingle: "Format Group in Single",
    groupInnerFormat: "Non-Speaker Inner Format",
    chatHTML: "Chat HTML",
    logShare: "Show Share Log Button",
    preview: "Preview",
    recommended: "Recommended",
    newChat: "New Chat",
    predictedOutput: "Predicted Output",
    systemContentReplacement: "System Content Replacement",
    systemRoleReplacement: "System Role Replacement",
    seperateParameters: "Separate Parameters",
    seperateParametersEnabled: "Enable Separate Parameters",
    summarizationPrompt: "Summarization Prompt",
    reSummarizationPrompt: "Re-Summarizaion Prompt",
    translatorPrompt: "Translation Prompt",
    translateBeforeHTMLFormatting: "Translate Before HTML Formatting",
    retranslate: "Retranslate",
    editTranslation: "Edit Translation",
    editTranslationSave: "Save Translation",
    exportTranslationCache: "Export Translation Cache",
    exportTranslationCacheSuccess: "Translation cache exported successfully.",
    importTranslationCache: "Import Translation Cache",
    importTranslationCacheConfirm: "This will merge entries into your translation cache. Existing keys will be overwritten. Continue?",
    importTranslationCacheSuccess: "Imported {0} translation cache entries.",
    importTranslationCacheFailed: "Imported {0} entries, but {1} entries failed to save. Storage may be full.",
    exportTranslationCacheEmpty: "Translation cache is empty.",
    clearTranslationCache: "Clear Translation Cache",
    clearTranslationCacheSuccess: "Translation cache cleared successfully.",
    clearTranslationCacheConfirm: "This will delete all translation cache entries. This cannot be undone. Continue?",
    loading: "Loading",
    autoTranslateCachedOnly: "Auto-translate Cached Messages Only",
    notification: "Notification",
    permissionDenied: "Permission Denied by Your Browser or OS",
    customFlags: "Custom Flags",
    enableCustomFlags: "Enable Custom Flags",
    googleCloudTokenization: "Google Cloud Tokenization",
    presetChain: "Preset Chain",
    legacyMediaFindings: "Legacy Media Findings",
    staticsDisclaimer: "The statistics are based on the data from after July 2024. the data may not be accurate.",
    subtitles: "Subtitles",
    subtitlesWarning1: "You must use model with audio/video input to use this feature.",
    subtitlesWarning2: "You must use model with streaming feature to use this feature.",
    reset: "Reset",
    clearInputConfirm: "Clear all the text in this field?",
    assetMaxDifference: "Asset Max Difference",
    sourceLanguage: "Source Language",
    destinationLanguage: "Destination Language",
    noWebGPU: "Your Browser or OS doesn't support WebGPU. this will slow down the performance significantly.",
    menuSideBar: "Menu Side Bar (Not recommended)",
    home: "Home",
    showSavingIcon: "Show Saving Icon",
    pluginVersionWarn:
        "This is {{plugin_version}} version of the plugin. which is not compatible with this version of PocketRisu. please update the plugin to {{required_version}} version.",
    imageTranslation: "Image Translation",
    banCharacterset: "Auto Regenerate On Characterset",
    realmDirectOpen: "Directly open character in RisuRealm",
    showPromptComparison: "Show Prompt Comparison",
    inlayErrorResponse: "Inlay Error Response",
    triggerOn: "Trigger On",
    noConfig: "No Config",
    varName: "Variable Name",
    var: "Variable",
    condition: "Condition",
    trigger: "Trigger",
    outputVar: "Output Variable",
    source: "Source",
    cmd: "Command",
    sysStart: "System Start",
    sysHistoryEnd: "System History End",
    sysPromptEnd: "System Prompt End",
    target: "Target",
    addElse: "Add Else",
    min: "Min",
    max: "Max",
    delimiter: "Delimiter",
    deleteCount: "Delete Count",
    triggerEffRunAxLLM: "Run Auxiliary Model",
    hypaV3Settings: {
        descriptionLabel: "HypaMemory V3 is a long-term memory system that uses both summarization and vector search.",
        supaMemoryPromptPlaceHolder: "Leave it blank to use default",
        maxMemoryTokensRatioLabel: "Max Memory Tokens Ratio (Estimated)",
        maxMemoryTokensRatioError: "Unable to calculate Max Memory Tokens Ratio",
        memoryTokensRatioLabel: "Memory Tokens Ratio",
        extraSummarizationRatioLabel: "Extra Summarization Ratio",
        maxChatsPerSummaryLabel: "Max Messages Per Summary",
        queryChatCountLabel: "Query Chat Count",
        summaryChunkSeparatorLabel: "Chunk Separator Regex",
        recentMemoryRatioLabel: "Recent Memory Ratio",
        similarMemoryRatioLabel: "Similar Memory Ratio",
        randomMemoryRatioLabel: "Random Memory Ratio",
        enableSimilarityCorrectionLabel: "Enable Similarity Correction",
        preserveOrphanedMemoryLabel: "Preserve Orphaned Memory",
        applyRegexScriptWhenRerollingLabel: "Apply Regex Script When Rerolling",
        doNotSummarizeUserMessageLabel: "Do Not Summarize User Message",
    },
    hypaV3Modal: {
        titleLabel: "HypaV3",
        resetConfirmMessage: "This action cannot be undone. Do you want to reset HypaV3 data?",
        resetConfirmSecondMessage: "This action is irreversible. Do you really, really want to reset HypaV3 data?",
        convertLabel: "No summaries yet, but you may convert HypaV2 data to V3.",
        convertButton: "Convert to V3",
        convertSuccessMessage: "Successfully converted HypaV2 data to V3",
        convertErrorMessage: "Failed to convert HypaV2 data to V3: {0}",
        noSummariesLabel: "No summaries yet",
        searchPlaceholder: "Enter #N, ID, or query",
        summaryNumberLabel: "Summary #{0}",
        deleteThisConfirmMessage: "Delete this summary?",
        deleteAfterConfirmMessage: "Delete all summaries after this one?",
        deleteAfterConfirmSecondMessage: "This action cannot be undone. Are you really sure?",
        translationLabel: "Translation",
        rerolledSummaryLabel: "Rerolled Summary",
        rerolledTranslationLabel: "Rerolled Summary Translation",
        connectedMessageCountLabel: "Connected Messages ({0})",
        connectedFirstMessageLabel: "First Message",
        connectedMessageRoleLabel: "{0}'s Message",
        connectedMessageNotFoundLabel: "Message not found",
        connectedMessageLoadingError: "Error loading connected message: {0}",
        connectedMessageTranslationLabel: "Translation",
        nextSummarizationFirstMessageLabel: "First Message",
        nextSummarizationNoMessageIdLabel: "No Message ID",
        nextSummarizationLabel: "HypaV3 will summarize [{0}]",
        nextSummarizationNoMessagesFoundLabel: "WARN: No messages found",
        nextSummarizationLoadingError: "Error loading next summarization target: {0}",
        summarizationConditionLabel: "Tip: HypaV3 begins summarization when input tokens exceed the maximum context size.",
        emptySelectedFirstMessageLabel: "WARN: Selected first message is empty",
        unclassified: "Unclassified",
        reSummarize: "Re-summarize",
        reSummarizing: "Re-summarizing...",
        reSummarizeResult: "Re-summarization result",
        retry: "Retry",
        translate: "Translate",
        tag: "Tag",
        tagManager: "Tag Manager",
        tagManagerTitle: "Tag Manager - Summary #{0}",
        newTagName: "New tag name",
        noTagsYet: "No tags yet.",
        addNewTagHint: "Add a new tag above.",
        categoryManager: "Categories",
        allCategories: "All",
        categoryName: "Category name",
        noCategoriesYet: "No categories yet.",
        addNewCategoryHint: "Click the + button above to add one.",
    },
    bulkEnabling: "Lorebook Bulk Enabling",
    showTranslationLoading: "Show Translation Loading",
    showDeprecatedTriggerV1: "Show Deprecated Trigger V1",
    showDeprecatedTriggerV2: "Show Deprecated Trigger V2",
    triggerV1Warning: "Trigger V1 is deprecated. it might be removed in the future.",
    copy: "Copy",
    paste: "Paste",
    depth: "Depth",
    returnCSSError: "Return CSS Error",
    alwaysActiveInChat: "Always Active (Current Chat)",
    childLoreDesc: "This is a copy of Character lore that remains 'Always Active' until removed or manually deactivated in the original.",
    thinkingTokens: "Thinking Tokens",
    thinkingType: "Thinking Mode",
    adaptiveThinkingEffort: "Adaptive Thinking Effort",
    antiServerOverload: "Anti-Server Overload",
    localActivationInGlobalLorebook: "Local Activation in Global Lorebook",
    cachePoint: "Cache Point",
    all: "All",
    showFolderNameInIcon: "Show Folder Name in Icon",
    claudeCachingRetrival: "Claude Caching Retrival",
    claudeCachingRetrivalDesc:
        "Extends the cache time for Claude Caching, by requesting every 4 minutes. this can reduce the cache miss rate, but it can increase the cost if its not used properly.",
    automaticCachePoint: "Automatic Cache Point",
    experimentalChatCompression: "Experimental Chat Data Handling",
    loadingChatData: "Loading Chat Data",
    selectChatToView: "Select a chat to view",
    outputImageModal: "Output Image Modal",
    playMessageOnTranslateEnd: "Play Audio on Translate Completion",
    soundAndNotification: "Sound & Notification",
    groupBrowserNotification: "Browser notification",
    groupMessageNotification: "Message-complete notification",
    groupTranslateNotification: "Translation-complete notification",
    notificationEnable: "Enabled",
    soundEffect: "Sound",
    soundEffectVolume: "Volume",
    selectNotificationSound: "Select notification sound",
    uploadSound: "Upload your own",
    uploadedSound: "Uploaded sound",
    soundDefault: "Default",
    descBrowserNotification: "Show a browser notification when a response completes.",
    descMessageSound: "Play a sound when a response completes.",
    descTranslateSound: "Play a sound when a translation completes.",
    auxModelUnderModelSettings: "Show Separate Aux Models in Model Settings",
    showModelInSidebar: "Show Model Selection in Sidebar",
    showPresetInSidebar: "Show Preset Selection in Sidebar",
    showPersonaInSidebar: "Show Persona Binding in Sidebar",
    disableMobileDragDrop: "Disable Character Drag & Drop on Mobile",
    disableToggleBinding: "Disable Chat Toggle Binding",
    seperateModelsForAxModels: "Separate Models for Auxiliary Models",
    axModelsDef: "Ax Models Definition",
    doNotChangeSeperateModels: "Do Not Change Seperate Models on Preset Change",
    useDefaultSubModel: "Use default submodel",
    modelPresetBindingMainUnset: "No main model preset is bound to this chat. Bind one to send.",
    modelPresetBindingSubUnset: "No submodel preset is bound to this chat. Bind one to send.",
    modelPresetBindingTitle: "Model/submodel preset binding",
    useModelPresetBindingToggle: "Use model preset binding",
    modelPresetConfigure: "Configure model presets",
    modelPresetSetDefaultConfirm: "Set the current model binding as the default for new chats?",
    modelPresetBindedSuccess: "Model preset is successfully binded",
    maxContextCapInfo: "Model profile limit: {} tokens. An empty or larger value is capped here.",
    maxContextCapExceeded: "Your value exceeds the model profile limit, so only {} tokens are used. Turn on \"Ignore model limit\" below to use it as entered.",
    maxContextIgnoreCap: "Ignore model limit",
    maxContextIgnoreCapHelp: "Enable when the profile's context limit is wrong. The value above is used as entered; exceeding the real limit produces an error from the service. No effect while the value is empty.",
    streamingOverride: "Response streaming",
    streamingOverrideHelp: "Whether this preset streams responses.",
    decoupledStreaming: "Decoupled streaming (show at once)",
    decoupledStreamingHelp: "Send the request over the streaming wire but display the full response at once after it completes. Bypasses some providers' non-streaming output limits and timeouts, and avoids token-by-token render cost.",
    modelPresetToolUse: "Tool use",
    modelPresetToolUseHelp: "Let this preset call your configured tools (MCP). Off by default. Tool runs are sent without streaming.",
    modelPresetAbilities: "Model abilities",
    modelPresetPickSuggestion: "Choose from suggestions…",
    modelPresetSnapshotEmpty: "This preset's profile data is empty. Re-download or replace the profile to restore its settings.",
    modelPresetImageInput: "Image input",
    modelPresetImageInputHelp: "Send images to the model. Off by default. Turn on only for models that accept images (e.g. Ollama gemma3, llava).",
    modelPresetFoldSystem: "Fold system prompt",
    modelPresetFoldSystemHelp: "Convert system messages into user turns before sending. Off by default. Turn on for models without a native system role (e.g. Ollama gemma3).",
    modelPresetKeepFirstSystem: "Keep first system prompt",
    modelPresetKeepFirstSystemHelp: "When folding, leave the leading system message as-is instead of converting it. For models that allow a single leading system message.",
    modelPresetAlternateRole: "Force alternating roles",
    modelPresetAlternateRoleHelp: "Merge consecutive same-role messages into one. Off by default. Turn on for models that require alternating user/assistant turns (e.g. gemma).",
    modelPresetStartWithUser: "Start with user input",
    modelPresetStartWithUserHelp: "Prepend an empty user turn when the conversation does not start with user. Off by default. For models that reject a non-user first turn.",
    modelPresetCacheSection: "Context caching",
    modelPresetCacheEnable: "Use context caching",
    modelPresetCacheEnableHelp: "Cache the repeated prompt prefix on Google's servers to cut input token cost. The cache boundary is set by the cache card in your prompt template (or Automatic Cache Point).",
    modelPresetCachePluginWarning: "Using this together with an external cache plugin causes conflicts and caching will not work correctly. Use only one of the two.",
    modelPresetCacheTtl: "Cache lifetime (seconds)",
    modelPresetCacheTtlHelp: "How long the server keeps the cache. Longer covers think time between turns, but storage cost accrues for the lifetime.",
    modelPresetCacheExtend: "Extend lifetime on hit",
    modelPresetCacheExtendHelp: "Renew the cache lifetime whenever a request hits the cache.",
    modelPresetCacheAdvanced: "Advanced",
    modelPresetCacheMinTokens: "Minimum prompt tokens",
    modelPresetCacheMinTokensHelp: "Do not create a cache while the prompt is below this size.",
    modelPresetCacheGrowth: "Recreate after growth (tokens)",
    modelPresetCacheGrowthHelp: "Recreate the cache once the prompt has grown by this many tokens since it was created.",
    maxContextHelp: "Input (prompt) token budget for this preset. Leave empty for the default (65000), capped at the model's context window. Not the response length (that is Max Tokens).",
    modelPresetTabPresets: "Presets",
    modelPresetTabOptions: "Settings",
    modelPresetTabTest: "Test",
    modelPresetTabModules: "Module Binding",
    moduleModelBindingEnable: "Per-Module Model Binding",
    moduleModelBindingUnset: "Not set",
    moduleModelBindingEmpty: "No installed module makes model calls.",
    moduleModelBindingDangling: "The assigned preset no longer exists. Pick another, or re-import the preset to reconnect.",
    modelPresetTestTitle: "Test request",
    modelPresetTestHelp: "Send a single message to this preset to check its credentials and endpoint respond. Not saved to any chat.",
    modelPresetTestSend: "Send test",
    modelPresetTestSending: "Sending…",
    modelPresetTestSuccess: "Success",
    modelPresetTestFail: "Failed",
    modelPresetTestDefault: "I want to wash my car. The car wash is 50 meters away. Should I walk or drive?",
    profileVisibilityLevel: "Profile visibility",
    profileVisibilityAll: "Show all",
    profileVisibilityHideDeprecated: "Hide deprecated",
    profileVisibilityCurrentOnly: "Current only",
    useCustomRegistry: "Custom registry",
    customRegistryUrl: "Registry URL",
    customRegistryWarning: "Only use a registry source you trust. A malicious registry could route requests — and your API keys — to an unintended server.",
    registryRefresh: "Sync registry",
    registryRefreshHelp: "Re-download the catalog from the current registry source.",
    registryRefreshNow: "Refresh now",
    registrySyncing: "Syncing…",
    registrySyncUpdated: "Updated to the latest catalog.",
    registrySyncUpToDate: "Already up to date.",
    registryRefreshed: "Refreshed.",
    registrySyncFailed: "Sync failed",
    modelPresetDeleted: "Deleted preset",
    modelPresetUnset: "Not set",
    modelPresetSetAsDefault: "Set current binding as default for new chats",
    modelPresetDefaultSaved: "Saved as default binding",
    modelPresetSaveAsDefaultButton: "Save as default",
    modelModeLabel: "Model mode",
    modelModeLegacy: "Legacy model",
    modelModePreset: "Model preset",
    modelModeSettingsTitle: "Open model mode settings",
    modelModeLockLabel: "Model mode setting",
    modelModeLockLegacy: "Lock to legacy model mode",
    modelModeLockLegacyDesc: "Use the original RisuAI model system",
    modelModeLockPreset: "Lock to model preset mode",
    modelModeLockPresetDesc: "Use PocketRisu's model preset binding system",
    modelModeLockNone: "No lock",
    modelModeLockNoneDesc: "Choose the mode per chat",
    newChatModelModeLabel: "Default model mode for new chats",
    modelTabBuiltin: "Built-in",
    modelTabPlugin: "Plugin",
    axModelMemory: "Memory",
    axModelTranslate: "Translation",
    axModelEmotion: "Emotion",
    axModelOther: "Other",
    tools: "Tools",
    action: "Action",
    hotkey: "Hotkey",
    hotkeyDesc: {
        reroll: "Reroll",
        unreroll: "Undo Reroll",
        translate: "Translate",
        remove: "Remove",
        edit: "Edit",
        copy: "Copy",
        send: "Send",
        settings: "Settings",
        home: "Home",
        presets: "Quick Presets Select",
        persona: "Quick Persona Select",
        modelSelect: "Quick Model Select",
        toggleCSS: "Toggle CSS",
        prevChar: "Previous Character",
        nextChar: "Next Character",
        quickMenu: "Quick Menu",
        quickSettings: "Quick Settings",
        toggleVoice: "Toggle Voice",
        toggleLog: "Toggle Log",
        previewRequest: "Preview Request",
        import: "Import",
        export: "Export",
        webcam: "Toggle Webcam",
        focusInput: "Focus Input",
        scrollToActiveChar: "Scroll to Active Character",
        popupEditor: "Popup Editor",
    },
    screenTooSmall: "Screen is too small to show the interface.",
    advancedModelSettings: "Advanced Model Settings",
    fallbackModel: "Fallback Model",
    fallbackWhenBlankResponse: "Fallback When Blank Response",
    doNotChangeFallbackModels: "Do Not Change Fallback Models on Preset Change",
    customModels: "Custom Models",
    igpPrompt: "IGP Prompt",
    useTokenizerCaching: "Tokenizer Caching",
    hypaMemoryV3Modal: "Hypa V3 Modal",
    showMenuHypaMemoryModal: "Show Menu Hypa Modal",
    promptInfoInsideChat: "Add Prompt Info to Chat",
    promptTextInfoInsideChat: "Add Prompt Text to Chat",
    promptInfoEmptyMessage: "No prompt information is available for this message.",
    promptInfoEmptyToggle: "No custom toggles are currently active.",
    promptInfoEmptyText: "No prompt text has been saved.",
    escapeOutput: "Escape Output",
    claudeBatching: "Claude Batching",
    claude1HourCaching: "Claude 1 Hour Caching",
    folderNameInput: "Please input the new folder name",
    folderRemoveLengthError: "To remove a folder, it must not contain any entries.",
    personaNote: "Persona Note",
    personaDuplicate: "Duplicate",
    mcpAccessPrompt: '{{tool}} is trying to "{{action}}". do you want to allow this?',
    rememberToolUsage: "Remember tool usage",
    simplifiedToolUse: "Simplified tool usage",
    toolCalled: "Tool '{{tool}}' Called",
    static: "Static",
    dynamic: "Dynamic",
    assetStyle: "Asset Style",
    insertAssetPrompt: "Insert Asset Prompt",
    requestLocation: "Request Location",
    newImageHandlingBeta: "New Image Handling (Beta)",
    settingsExported: "Settings for bug report exported and copied to clipboard.",
    bookmarks: "Bookmarks",
    noBookmarks: "No Bookmarks",
    bookmarkAskNameOrDefault: "Enter bookmark name. If not entered, it will be automatically assigned.",
    bookmarkAskNameOrCancel: "Enter bookmark name. If not entered, rename will be canceled.",
    collapseAll: "Collapse All",
    expandAll: "Expand All",
    hideErrorDetails: "Hide Error Details",
    showErrorDetails: "Show Error Details",
    dynamicOutput: "Dynamic Output",
    autoAdjustSchema: "Auto Adjust Schema",
    dynamicMessages: "Dynamic Messages",
    dynamicMemory: "Dynamic Memory",
    dynamicResponseTiming: "Dynamic Response Timing",
    showTypingEffect: "Show Typing Effect",
    dynamicRequest: "Dynamic Request",
    dynamicOutputPrompt: "Dynamic Output Prompt",
    settingsCloseButtonSize: "Settings Close Button Size",
    translating: "Translating...",
    stackTraceTranslationFailed: "Stack trace translation failed. Showing original obfuscated stack trace below.",
    apply: "Apply",
    send: "Send",
    add: "Add",
    nightlyWarning:
        "## Nightly Builds\n\nYou are connecting to a nightly build of the software. This version is meant for testing and most likely contains bugs. **In this version, even if you encounter issues, we do not support resolving them directly.**",
    loginSionyw: "Login with Sionyw Account",
    pluginRiskDetectedAlert: "PocketRisu detected code that may be harmful which can STOLE YOUR API KEY OR PERSONAL DATA. we recommend you to NOT INSTALL THIS PLUGIN.",
    doNotInstall: "Do Not Install",
    continueAnyway: "Continue Anyway",
    pluginNoRiskButAlert: "PocketRisu did not detect harmful code, but please be aware that installing plugins from untrusted sources can pose security risks.",

    pluginRisksInuserFriendly: {
        eval: "Evaluating Code from Strings",
        globalAccess: "Accessing Global Variables",
        thisOutsideClass: "Using 'this' Outside of Class Context",
        errorInVerification: "Errors During Verification Process",
        storageAccess: "Accessing Storage",
    },
    pluginRisksInuserFriendlyDesc: {
        eval: "The plugin attempts to execute code from strings, strings can be obsucated to hide malicious code.",
        globalAccess: "The plugin tries to access global variables, which can lead to unintended side effects or security vulnerabilities.",
        thisOutsideClass: "The plugin uses 'this' keyword outside of class context, which can lead to unintended behavior or security issues.",
        errorInVerification: "There are errors during the verification process of the plugin, indicating potential issues with its functionality.",
        storageAccess: "The plugin attempts to access storage, which could lead to data leaks or unauthorized data manipulation.",
    },
    generatedByAIDisclaimer: "This content was generated by AI and may contain inaccuracies or biases.",
    aiGenerationWarning: "Contents will be AI generated and may contain inaccuracies or biases.",
    duplicatePluginFoundUpdateIt: "Duplicate plugin found. do you want to update the existing plugin?",
    pluginUpdateFoundInstallIt: "Plugin update found. do you want to install the update?",
    goToChat: "Go to Chat",
    bookmark: "Bookmark",
    translate: "Translate",
    branch: "Branch",
    branchedText: "This chat has been branched from {}.",
    loadMore: "Load More",
    disableMessage: "Disable Message",
    disableFirstMessageConfirm: "Disable the personal message? It will be excluded from the context.",
    disableAbove: "Cut Messages for AI",
    autoScrollToNewMessage: "Auto scroll to new message",
    alwaysScrollToNewMessage: "Always scroll to new message (ignore scroll position)",
    newMessage: "New Message",
    newMessageButtonStyle: "New Message Button Style",
    newMessageButtonBottomCenter: "Bottom Center (Default)",
    newMessageButtonBottomRight: "Bottom Right",
    newMessageButtonBottomLeft: "Bottom Left",
    newMessageButtonFloatingCircle: "Floating Circle (Bottom Right)",
    newMessageButtonRightCenter: "Right Center",
    newMessageButtonTopBar: "Top Bar",
    trimStartNewChat: "Trim 'Start New Chat' Messages",
    pluginDevelopMode: "Plugin Develop Mode",
    fetchLogConsent: "Plugin {} is requesting to fetch logs, which may expose sensitive information. Do you want to allow this?", 
    getFullDatabaseConsent: "Plugin {} is requesting to access the full database, which may expose sensitive information. Do you want to allow this?",
    mainDomAccessConsent: "Plugin {} is requesting to access the main Document, which may expose sensitive information. Do you want to allow this?",
    replacerPermissionConsent: "Plugin {} is requesting permission to replace content in the chat, which may be used to manipulate the conversation. Do you want to allow this?",
    providerPermissionConsent: "Plugin {} is requesting permission to access the provider, which may allow it to make unauthorized API calls. Do you want to allow this?",
    inlayPermissionConsent: "Plugin {} is requesting permission to access the inlay, which may allow it to read, write or edit the inlay content. Do you want to allow this?",
    sendChatConsent: "Plugin {} is requesting permission to send chat messages on your behalf, which will trigger AI responses. Do you want to allow this?",
    pluginPermissionDenyGuide: "Permission request from plugin \"{}\" was denied. Denied permissions will not be asked again.\n\nIf this was a mistake, you can undo it with \"Reset permission responses\" for this plugin in [Settings] > [Plugins].",
    pluginFullStorageAccess: "Provide all plugin data (RisuAI compatible)",
    pluginFullStorageAccessDesc: "Hands every plugin's stored data to this plugin whenever it reads the database. The whole plugin storage ({} right now) is copied on each read, so enable it only for plugins that need other plugins' data.",
    pluginFullStorageAccessLarge: "Plugin storage is over 100 MB. Enabling this for a plugin that reads often can slow down or freeze the app.",
    pluginFullStorageAccessGuide: "Learn more",
    resetPluginPermission: "Reset permission responses",
    resetPluginPermissionConfirm: "Clear all saved permission responses (granted / denied history) for plugin \"{}\"?\n\nThe plugin will be asked again the next time it requests permission.",
    resetPluginPermissionDone: "Permission responses for \"{}\" have been reset",
    pluginV2Warning: "Plugin V2 and V2.1 is considered unsafe and will stop working in future versions. **Please do not use these versions of plugins.**. If you are the developer of this plugin, please update to V3 as soon as possible.",
    createFolderOnBranch: "Create Folder on Branch",
    hamburgerButtonBottom: "Move Menu Button to Bottom of Sidebar",
    hideLeftBarCollapseButton: "Hide Left Bar Collapse Button",
    partialBackupFirstConfirm: "⚠️ WARNING: Partial Local Backup ⚠️\n\nThis backup quickly saves only essential information.\n\nIncluded:\n- Database (chat history, characters, modules, plugins, prompts, settings, etc.)\n- Character profile icons (main images)\n- User icons and custom backgrounds\n- Persona icons\n- Folder images\n- Bot preset images\n\n⚠️ NOT Included:\n- Emotion images\n- Additional character assets\n- VITS voice files\n- All other additional media files\n\nThis backup file does NOT include all character assets!\nIf you need a complete backup, use the regular local backup.\n\nDo you want to continue?",
    partialBackupSecondConfirm: "⚠️⚠️ FINAL WARNING ⚠️⚠️\n\nThis backup saves only character profile images and does NOT save most other assets!\n\nWhat will be saved:\n- Database (chat history, characters, modules, plugins, prompts, settings, etc.)\n- Character profile icons (main images)\n- User icons and custom backgrounds\n- Persona icons\n- Folder images\n- Bot preset images\n\nWhat will NOT be saved:\n- Emotion images\n- Additional character assets\n- VITS voice files\n- All other media files\n\n⚠️ Proceed ONLY if you don't need character assets in your backup file! ⚠️\n\nAre you really sure you want to proceed with partial backup?",
    savePartialLocalBackup: "Save Partial Backup Locally (Excluding Character Assets)",
    serverBackupHeader: "PocketRisu Server Backup",
    serverBackupDesc: "Save and restore backup files directly on the device (server) where PocketRisu is installed, without downloading.",
    serverBackupSave: "Save Backup to Server",
    serverBackupManage: "Manage Server Backups",
    serverBackupSaving: "Saving backup to server...",
    pluginStorageV2PreloadFailed: "Plugin storage could not be loaded, so V2 plugins were not started. Reload to try again.",
    serverBackupSaveSuccess: (filename: string, size: string, dir?: string) => `Backup saved: ${filename} (${size})${dir ? ` in ${dir}` : ''}`,
    serverBackupLoading: "Loading backup list...",
    serverBackupEmpty: "No server backups found.",
    serverBackupRestore: "Restore",
    serverBackupDownload: "Download",
    serverBackupDelete: "Delete",
    serverBackupRestoring: "Restoring backup from server...",
    serverBackupDownloading: "Downloading backup...",
    serverBackupDeleteConfirm: (filename: string) => `Delete backup "${filename}"? This cannot be undone.`,
    serverBackupDeleteSuccess: "Backup deleted.",
    pluginProviderNotFound: "Unknown Plugin detected. please change the model or enable the corresponding plugin.",
    bootstrap: {
        dataCorruptionDetected: (name: string, type: string) => `Data Corruption Detected\n\nModule "${name}" has corrupted lorebook format.\n\nCorrupted data type: ${type}`,
        reportErrorQuestion: "Would you like to report this error to the developer?\nThis helps prevent the same error from happening again.\n(Only includes Corrupted module info, no personal data)",
        diagnosticInformation: (reportData: string) => `# Diagnostic Information\n\nPlease copy the information below and report it to the developer via GitHub Issues, Discord, or community.\nDouble-check for any sensitive information before reporting.\n\n\`\`\`json\n${reportData}\n\`\`\``,
        resetLorebookQuestion: "Do you want to reset ONLY the lorebook data in this specific corrupted module?\n(Other modules and character data will NOT be affected)\n\nChoosing \"No\" will keep the data but errors may continue.",
    },
    partialEdit: {
        editButtonTooltip: "Edit",
        deleteButtonTooltip: "Delete",
        deleteModalTitle: "Delete Confirmation",
        deleteConfirmMessage: "Are you sure you want to delete this part?",
        deleteYes: "Yes",
        deleteNo: "No",
        editModalTitle: "Partial Edit",
        matchFound: (method: string) => `Match: ${method}`,
        matchFailedTitle: "Cannot Partial Edit",
        matchFailedMessage: "Unable to locate precisely in the original message. This may happen with very long sentences or duplicate content. Please use the full message edit feature instead.",
        selectMatch: "Select which block to edit",
        selectDeleteMatch: "Select which block to delete",
        matchesFound: "matches found",
        lineNumber: (line: number) => `Line ~${line}`,
        saveShortcut: "Save (Ctrl+Enter)",
        cancelShortcut: "Cancel (Esc)",
        save: "Save",
        cancel: "Cancel",
    },
    enableRemoteSaving: "Enable Remote Saving",
    blockquoteStyling: "Blockquote Styling",
    dynamicModelRegistry: "Dynamic Model Registry",
    confirmInstallPluginViaPlugin: "You are trying to install a plugin via another plugin. This can be dangerous if the source plugin is not trustworthy. Do you want to continue?",
    nodeOnlyRestoreLastChat: "Reopen Last Chat on Start",
    nodeOnlyScrollButtonType: "Scroll Button Type",
    scrollButtonTypeFour: "4 Buttons",
    scrollButtonTypeTwo: "2 Buttons",
    scrollButtonTypeOff: "Off",
    nodeOnlyServerSideRequests: "Server-Side Requests",
    pendingSendNotice: "Unfinished send: {chars} — opening the chat will resume it.",
    seperateParametersByModel: "Separate Parameters by Model",
    disableSeperateParameterChangeOnPresetChange: "Disable Separate Parameter Change on Preset Change",
    keepSessionAlive: "Keep Session Alive",
    keepSessionAlivePip: "Via PIP",
    keepSessionAliveSound: "Via Sound",
    toggleBindingLabel: "Toggle Binding",
    togglePinToChat: "Bind toggles to chat",
    togglePinLabel: "Bind",
    togglePinSaved: "Toggles bound.",
    toggleSaveAsDefaultButton: "Save as default",
    toggleSetDefaultConfirm: "Save the current toggle state as the default for new chats? New chats will start bound to it.",
    toggleDefaultSaved: "Saved as toggle default",
    toggleDefaultSavedButton: "Default saved",
    toggleDefaultManage: "A toggle default for new chats is saved.",
    toggleDefaultOverwrite: "Overwrite with current state",
    toggleDefaultClear: "Clear default",
    toggleDefaultCleared: "Toggle default cleared. New chats start unbound.",
    toggleSaveAsPreset: "Save as toggle preset",
    toggleLoadPreset: "Load toggle preset",
    togglePinUpdate: "Save toggles",
    togglePinUpdateLabel: "Save",

    togglePinRemove: "Unbind toggles?",
    togglePinUnbound: "Toggles unbound.",
    togglePresetNamePrompt: "Enter toggle preset name",
    togglePresetDelete: "── Delete ──",
    togglePresetDeleteConfirm: (name: string) => `Delete toggle preset "${name}"?`,
    togglePresetSelectTitle: "Toggle Presets",
    togglePresetEmpty: "No toggle presets saved.",
    togglePresetRename: "Rename toggle preset",
    togglePresetApplied: (name: string) => `"${name}" preset applied.`,
    togglePresetFilterShowAll: "Show all presets",
    togglePresetNoPromptPreset: "No preset",
    togglePresetEmptyFiltered: "No toggle presets for the current prompt preset.",
    togglePresetApplyConfirm: "Current toggle settings will be overwritten. Apply?",
    togglePresetMismatchConfirm: "This preset was saved for a different prompt preset. Toggles may not be compatible. Apply anyway?",
    togglePresetSaveNew: "Save New Preset",
    togglePresetOverwrite: "Overwrite",
    togglePresetOverwriteConfirm: (name: string) => `Overwrite "${name}" with current toggle values?`,
    togglePresetOverwritten: (name: string) => `Preset "${name}" overwritten.`,
    togglePresetList: "Toggle Presets",
    togglePresetMenuRename: "Rename",
    togglePresetMenuDuplicate: "Duplicate",
    togglePresetMenuDelete: "Delete",
    togglePresetMenuOverwrite: "Overwrite",
    togglePresetMenuExport: "Export",
    togglePresetImport: "Import from File",
    togglePresetImported: (name: string) => `Preset "${name}" imported.`,
    togglePresetImportError: "Invalid toggle preset file.",
    togglePresetSaved: (name: string) => `Preset "${name}" saved.`,
    togglePresetRenamed: (oldName: string, newName: string) => `Renamed "${oldName}" to "${newName}".`,
    togglePresetDuplicated: (name: string) => `Duplicated as "${name}".`,
    togglePresetDeleted: (name: string) => `Preset "${name}" deleted.`,
    togglePresetExported: (name: string) => `Preset "${name}" exported.`,
    longPressToPopupEditor: "Long press to open popup editor",
    showInputActionBar: "Show input action bar",
    importSaveFolderHeader: "Load Save into PocketRisu",
    importSaveZip: "Load from Save Folder (Zip Upload)",
    importSaveZipDesc: "Compress your existing RisuAI project's save folder into a zip file and upload it here to import your data. Uploading may fail if the zip file is too large — in that case, copy the save folder directly into the server's save directory and restart to migrate automatically.",
    importSaveFolderScanning: "Scanning save folder...",
    importSaveFolderImporting: "Importing save folder...",
    importSaveFolderConfirmZip: (name: string, size: string) => `Upload "${name}" (${size}) and import? This will replace your current data.`,
    importSaveFolderNoDatabase: "The save folder does not contain a database file (database/database.bin). Import cannot proceed.",
    importSaveFolderSuccess: "Import complete.",
    cleanupMigratedFiles: "Clean Up Migrated Save Files",
    cleanupMigratedDesc: "If you manually copied save files into the server's save folder, this removes the leftover original files after migration to free up disk space.",
    cleanupMigratedConfirm: (count: number, size: string) => `Delete ${count} migrated hex files (${size})? These are already in the database.`,
    cleanupMigratedNoFiles: "No migrated files to clean up.",
    cleanupMigratedNotReady: "Migration has not been completed yet. Cannot clean up.",
    cleanupMigratedSuccess: (count: number, size: string) => `Removed ${count} files, freed ${size}.`,
    cleanupMigratedCleaning: "Cleaning up migrated files...",
    // NanoGPT Dashboard
    nanoGPTLoadingAccountInfo: "Loading account info…",
    nanoGPTCreditBalance: "Credit Balance:",
    nanoGPTSubscription: "Subscription",
    nanoGPTGraceUntil: (date: string) => `until ${date}`,
    nanoGPTNoActiveSubscription: "No active subscription.",
    nanoGPTCancelsAtPeriodEnd: (date: string) => `Cancels at period end (${date})`,
    nanoGPTWeeklyTokens: (pct: string) => `Weekly Included Input Tokens — ${pct} used`,
    nanoGPTDailyTokens: (pct: string) => `Daily Included Input Tokens — ${pct} used`,
    nanoGPTDailyImages: (pct: string) => `Daily Included Images — ${pct} used`,
    nanoGPTResets: (date: string) => `Resets ${date}`,
    nanoGPTUsed: (n: string) => `${n} used`,
    nanoGPTRemaining: (n: string) => `${n} remaining`,
    nanoGPTRenews: (date: string) => `Renews: ${date}`,
    nanoGPTCouldNotLoadAccountInfo: "Could not load account info.",
    nanoGPTWeeklyTokensLabel: "Weekly Included Input Tokens",
    nanoGPTDailyTokensLabel: "Daily Included Input Tokens",
    nanoGPTDailyImagesLabel: "Daily Included Images",
    nanoGPTUsedLabel: "used",
    nanoGPTRemainingLabel: "remaining",
    nanoGPTResetsLabel: "Resets",
    nanoGPTRenewsLabel: "Renews:",
    // NanoGPT Provider Picker
    nanoGPTProvider: "Provider",
    nanoGPTProviderPayAsYouGoOnly: "(only available in pay-as-you-go mode)",
    nanoGPTProviderAuto: "Auto",
    nanoGPTProviderFree: "Free",
    nanoGPTProviderInput: "Input",
    nanoGPTProviderOutput: "Output",
    nanoGPTProviderQuantization: "Quantization",
    nanoGPTProviderUndisclosed: "Undisclosed",
    nanoGPTProviderCache: "Cache",
    nanoGPTProviderCacheSupported: "Supported",
    nanoGPTProviderCacheNotSupported: "Not supported",
    nanoGPTProviderCacheRead: "Cache read",
    // NanoGPT Settings
    nanoGPTUseSubscriptionEndpoint: "Use subscription endpoint & models",
    // Model Grid
    modelGridCouldNotLoad: "Could not load model list. Check your API key.",
    modelGridNoModelsMatch: (q: string) => `No models match "${q}"`,
    modelGridContext: (n: string) => `Context: ${n}`,
    nanoGPTSelectFromList: "Select from List",
    nanoGPTManualInput: "Manual Input",
    nanoGPTManualModelSelect: "Manual Model Select",
    searchSettingsPlaceholder: "Search settings...",
    searchSettingsNoResults: "No matching settings found",
    searchSettingsHint: "Search by setting name or keyword",
    // Remote Access (Cloudflare Quick Tunnel)
    remoteAccess: "Remote Access",
    remoteAccessDesc: "Use a remote access link to connect to this PocketRisu server from another device.",
    remoteAccessOpen: "Open Remote Access",
    remoteAccessClose: "Close Remote Access",
    remoteAccessCloseConfirm: "Close remote access? The link will expire.",
    remoteAccessDownloading: "Downloading cloudflared...",
    remoteAccessStarting: "Starting tunnel...",
    remoteAccessCopyUrl: "Copy URL",
    remoteAccessCopied: "Copied!",
    remoteAccessDisabled: "Remote access is disabled by server configuration.",
    remoteAccessError: "Tunnel error",
    remoteAccessRetry: "Retry",
    remoteAccessQrHint: "Scan QR code to connect",
    remoteAccessWarning: "Never share the QR code or link with others. Anyone with the link can freely access your server. If accidentally shared, close the connection and create a new one.",
    remoteAccessInfo: "The link expires when you close remote access or restart the server. A new link is generated each time. The connection stays active even if you close this page or browser.",
    remoteAccessTermuxWarning: "Cloudflare Quick Tunnel does not work on Termux. Use Tailscale or another remote access tool instead.",

    // Insecure (HTTP) connection warning
    httpInsecureWarningTitle: "Connected over HTTP",
    httpInsecureWarningBody: "Some features such as plugins may not work. Use the Remote Access feature for an HTTPS connection.",
    httpInsecureOpenRemoteAccess: "Open settings",

    // System page
    system: "System",
    systemLogs: "System Logs",
    systemLogsDesc: "View errors, warnings, and info events captured across this server and connected browsers.",
    systemLogsEmpty: "No logs yet",
    systemLogsEmptyDesc: "Errors and warnings will appear here as they occur.",
    systemLogsEmptyButMore: "No entries loaded yet match your client-side filters. Load more to search further back.",
    systemLogsSearchPlaceholder: "Search message, source, platform, or client ID",
    systemLogsLoadMore: "Load more",
    systemLogsRefresh: "Refresh",
    systemLogsCopyAll: "Copy visible",
    systemLogsCopyEntry: "Copy",
    systemLogsClearAll: "Clear all",
    systemLogsClearConfirm: "Delete all log entries? This cannot be undone.",
    systemLogsCopied: "Copied to clipboard",
    systemLogsFiltered: (shown: number, total: number) => `${shown} of ${total} shown`,
    systemLogsLevelAll: "All levels",
    systemLogsLevelError: "Error",
    systemLogsLevelWarning: "Warning",
    systemLogsLevelInfo: "Info",
    systemLogsOriginAll: "All",
    systemLogsOriginClient: "Client",
    systemLogsOriginServer: "Server",
    systemLogsFailedLoad: "Failed to load logs",
    systemLogsLoading: "Loading...",
    pluginStorageTab: "Plugin Storage",
    pluginStorageDesc: "View, edit and delete data saved by plugins. Plugin data is shared in a single global namespace, not separated per plugin.",
    pluginStorageBackendSave: "Save File",
    pluginStorageBackendSaveDesc: "Stored in the save file · travels with your save",
    pluginStorageBackendLocal: "Local",
    pluginStorageBackendLocalDesc: "localStorage based · strings only · device-local",
    pluginStorageBackendIdb: "Device DB",
    pluginStorageBackendIdbDesc: "IndexedDB based · JSON · device-local",
    pluginStorageSearchKey: "Search key...",
    pluginStorageSearchValue: "Search value...",
    pluginStorageRefresh: "Refresh",
    pluginStorageEmpty: "No entries.",
    pluginStorageLoadError: "Failed to load storage.",
    pluginStorageNotLoaded: "loads on open",
    pluginStorageSave: "Save",
    pluginStorageFormatJson: "Format JSON",
    pluginStorageMetaType: "Type",
    pluginStorageMetaSize: "Size",
    pluginStorageMetaChars: "Chars",
    pluginStorageOwner: "Origin",
    pluginStorageOwnerUnknown: "Unknown",
    pluginStorageDeleted: "Deleted",
    pluginStorageJsonError: (msg: string) => `JSON parse failed: ${msg}`,
    pluginStorageSaved: (key: string) => `Saved "${key}"`,
    pluginStorageDeleteConfirm: (key: string) => `Delete "${key}"?`,
    pluginStorageBulkDeleteShown: (n: number) => `Delete shown (${n})`,
    pluginStorageBulkDeleteAll: (n: number) => `Clear all (${n})`,
    pluginStorageBulkDeleteConfirm: (backend: string, n: number) => `Delete ${n} item(s) from the ${backend} backend? This cannot be undone.`,
    pluginStorageBulkDeleteAllConfirm: (backend: string, n: number) => `Delete ALL ${n} plugin storage item(s) from the ${backend} backend? This cannot be undone.`,
    pluginStorageBulkDeleted: (n: number) => `Deleted ${n} item(s)`,
    systemLogsFilters: "Filters",
    systemLogsFilterLevel: "Level",
    systemLogsFilterOrigin: "Origin",
    systemLogsFilterSource: "Source",
    systemLogsFilterDevice: "Device",
    systemLogsFilterClear: "Reset filters",
    systemLogsFilterActive: (count: number) => count === 0 ? '' : `${count} excluded`,
    systemLogsExplicitOnly: "Explicit logs only",
    systemLogsExplicitOnlyHint: "Excludes console, uncaught exceptions, framework captures",

    // Request logs / usage (system settings)
    requestLogsTab: "Request Logs",
    requestLogsDesc: "Records the body, response and timing of every request sent to a provider.",
    requestLogsFilters: "Filters",
    requestLogsFilterClear: "Clear filters",
    requestLogsFilterActive: (count: number) => count === 0 ? "" : `${count} active`,
    requestLogsFilterCategory: "Type",
    requestLogsFilterSource: "Source",
    requestLogsFilterResult: "Result",
    requestLogsCategoryLlm: "LLM",
    requestLogsCategoryTts: "Speech",
    requestLogsCategoryImage: "Image",
    requestLogsCategoryTranslate: "Translate",
    requestLogsCategoryEmbedding: "Embedding",
    requestLogsCategoryOther: "Other",
    requestLogsSourceMain: "Chat",
    requestLogsSourceTranslate: "Translate",
    requestLogsSourceMemory: "Memory",
    requestLogsSourceEmotion: "Emotion",
    requestLogsSourceSub: "Auxiliary",
    requestLogsSourcePreview: "Preview",
    requestLogsSourceTest: "Test",
    requestLogsSourceTts: "Speech",
    requestLogsSourceImage: "Image",
    requestLogsSourcePlugin: "Plugin",
    requestLogsSourceOther: "Other",
    requestLogsResultSuccess: "Success",
    requestLogsResultFailed: "Failed",
    requestLogsRouteDirect: "Direct",
    requestLogsRouteProxy: "Proxy",
    requestLogsRouteJob: "Backend call",
    requestLogsSearchPlaceholder: "Search by URL, model, or error message",
    requestLogsRefresh: "Refresh",
    requestLogsClearAll: "Clear all",
    requestLogsClearConfirm: "Delete all stored request logs? Usage statistics are kept.",
    requestLogsEmpty: "No logs yet",
    requestLogsEmptyDesc: "Requests you send will be recorded here.",
    requestLogsEmptyButMore: "Nothing matches the current filter. Try loading more.",
    requestLogsLoading: "Loading...",
    requestLogsFailedLoad: "Failed to load request logs",
    requestLogsLoadMore: "Load more",
    requestLogsCount: (shown: number, total: number) => shown === total ? `${total}` : `${shown} / ${total}`,
    requestLogsDuration: "Duration",
    requestLogsFirstToken: "First token",
    requestLogsTokens: "Tokens",
    requestLogsRequestHeaders: "Request headers",
    requestLogsRequestBody: "Request body",
    requestLogsResponse: "Response",
    requestLogsError: "Error",
    requestLogsCopied: "Copied to clipboard",
    requestLogsTruncated: "Truncated",
    requestLogsEnabled: "Record request logs",
    requestLogsEnabledDesc: "When off, new requests are not recorded. Usage statistics stop as well.",
    requestLogsStreamUsage: "Collect tokens on streamed requests",
    requestLogsStreamUsageDesc: "Asks the provider to report token usage for streamed responses. Some providers reject this with a 400 error — turn it off if that happens.",
    requestLogsStorage: (used: string, max: string) => `Storage ${used} / ${max}`,

    usageTab: "Usage",
    usageDesc: "Token usage for LLM requests. Requests without tokens (speech, images) are excluded.",
    usageRequests: "Requests",
    usageInputTokens: "Input tokens",
    usageOutputTokens: "Output tokens",
    usageCachedTokens: "Cached tokens",
    usageChartTitle: "Token usage",
    usageByModel: "By model",
    usageBySource: "By source",
    usageModel: "Model",
    usageAvgDuration: "Avg. latency",
    usageFailed: "Failed",
    usagePeriod7d: "7 days",
    usagePeriod30d: "30 days",
    usagePeriod90d: "90 days",
    usagePeriodAll: "All",
    usageEmpty: "No usage recorded yet",
    usageEmptyDesc: "Statistics build up as you send requests.",
    usageLoading: "Loading...",
    usageFailedLoad: "Failed to load usage",
    usageClearConfirm: "Delete all usage statistics? This cannot be undone.",
    usageClearAll: "Clear statistics",

    // Storage dashboard
    systemDashboard: "Dashboard",
    storageDashboardDesc: "Inspect storage usage, find large items, and reclaim space.",
    storageRefresh: "Refresh",
    storageLoading: "Loading...",
    storageFailedLoad: "Failed to load storage stats",

    // Disk usage section (macOS-style bar)
    storageDiskUsage: "Storage",
    storageDiskHeader: (used: number, total: number) =>
        `${(used / 1024 / 1024 / 1024).toFixed(2)} GB used of ${(total / 1024 / 1024 / 1024).toFixed(2)} GB`,
    storageDiskHeaderUnknown: "Disk size unavailable",
    storageDiskOther: "Other (system & apps)",
    storageDiskFree: "Free",
    storageDiskRisuTotal: (size: number) => `PocketRisu total: ${(size / 1024 / 1024).toFixed(1)} MB`,

    // Per-row labels (shown in the breakdown list with ⓘ explanations)
    storageRowDbFile: "risuai.db",
    storageRowDbFileDesc: "The main SQLite database file. Contains every chat, character, asset, and setting.",
    storageRowWal: "WAL (Write-Ahead Log)",
    storageRowWalDesc: "Transient transaction log. Saves are written here first, then folded into the main file. Normal during use.",
    storageRowShm: "SHM (shared memory)",
    storageRowShmDesc: "SQLite's shared memory index for the WAL. Tiny, transient, regenerated as needed.",
    storageRowFileBackups: "Disk backups (.bin)",
    storageRowFileBackupsDesc: "Manual export backups stored on disk under the backups/ folder.",
    storageRowKvDatabase: "database.bin (live)",
    storageRowKvDatabaseDesc: "The single BLOB inside risuai.db that holds character metadata, chats, and settings. Subject to the 2 GB single-blob limit.",
    storageRowKvDbBackups: "In-process DB backups",
    storageRowKvDbBackupsDesc: "Automatic snapshots of database.bin kept inside risuai.db. Rotated to fit within ~500 MB.",
    storageRowKvAssets: "Character assets",
    storageRowKvAssetsDesc: "Character cards, emotion images, additional assets, persona icons, and similar media.",
    storageRowKvInlay: "Inlay images",
    storageRowKvInlayDesc: "Images embedded inside chat messages (inlay + thumb + metadata).",
    storageRowKvRemotes: "Remote chat data",
    storageRowKvRemotesDesc: "Per-character remote sync cache (remotes/{chaId}.local.bin).",
    storageRowKvColdStorage: "Cold storage",
    storageRowKvColdStorageDesc: "Legacy/dormant storage tier. Usually empty.",
    storageRowKvUncategorized: "Other data",
    storageRowKvUncategorizedDesc: "Keys not matching any known category. Usually migration leftovers or temporary entries.",
    storageRowSqliteOverhead: "SQLite overhead (structural)",
    storageRowSqliteOverheadDesc: "Structural pages SQLite always keeps: indexes, page headers, alignment padding. Not user data and not removable by cleanup (grows naturally with data volume).",
    storageRowReclaimablePages: "SQLite overhead (reclaimable)",
    storageRowReclaimablePagesDesc: "Empty pages left behind by deleted data — the reclaimable portion of SQLite overhead. Same value as the yellow segment in the \"Clean up SQLite overhead\" bar below; cleanup reclaims all of them.",
    storageRowReclaimable: (size: number) =>
        `${(size / 1024 / 1024).toFixed(1)} MB reclaimable — run Optimize to compact.`,
    storageInternalOnly: "Show with full disk",
    storageInternalOnlyHint: "Off shows only PocketRisu items; on includes system & free space relative to the disk.",

    // 2 GB BLOB limit (separate section)
    storageBlobLimit: "2 GB BLOB limit",
    storageBlobLimitDesc: "SQLite caps a single row's value at ~2 GB. database.bin is one row, so chats and settings combined cannot exceed it. Saves start failing as you approach this limit.",
    storageBlobThreshold: (used: number, max: number, pct: number) =>
        `${pct.toFixed(1)}% of 2 GB (${(used / 1024 / 1024 / 1024).toFixed(2)} / ${(max / 1024 / 1024 / 1024).toFixed(2)} GB)`,
    storageBlobThresholdWarn: "Approaching the 2 GB single-blob limit. Reduce chats or assets.",
    storageBlobThresholdCrit: "Critical: very close to 2 GB blob limit. Saves may start failing.",

    storageOptimize: "Clean up now",
    storageOptimizing: "Cleaning up...",
    storageOptimizeHeader: (dbSize: number, reclaim: number) =>
        `${(reclaim / 1024 / 1024).toFixed(1)} MB reclaimable of ${(dbSize / 1024 / 1024 / 1024).toFixed(2)} GB`,
    storageOptimizeBarUsed: "In use",
    storageOptimizeBarReclaimable: "Reclaimable",
    storageOptimizeWhat: "When you delete characters, chats, or assets, the database marks the space as empty but does not shrink the file. Cleanup removes that empty space and rewrites the file to make it smaller on disk. Data is not modified.",
    storageOptimizeWhen: "Run this after a large delete, or when the empty-space portion in the bar above grows. Saves pause briefly during cleanup (usually a few seconds; tens of seconds for very large databases).",
    storageOptimizeConfirm: "Clean up now? Server saves will pause for a few seconds.",
    storageOptimizeNeedsSpace: (need: number, free: number) =>
        `Not enough disk space. Need ~${(need / 1024 / 1024).toFixed(0)} MB, free ${(free / 1024 / 1024).toFixed(0)} MB.`,
    storageOptimizeDone: (reclaimed: number, ms: number) =>
        `Reclaimed ${(reclaimed / 1024 / 1024).toFixed(1)} MB in ${(ms / 1000).toFixed(1)}s.`,
    storageOptimizeFailed: "Cleanup failed",

    storageCleanup: "Clean up SQLite overhead",

    storageOrphan: "Orphan media",
    storageOrphanHeader: (count: number, size: number) =>
        `${count} files · ${(size / 1024 / 1024).toFixed(1)} MB`,
    storageOrphanWhat:
        "Image files no character, module or persona refers to. They are left behind when you delete a character or replace an asset.",
    storageOrphanWhen:
        "Deleted files cannot be recovered — make a backup first if anything here matters. After purging, run \"Clean up SQLite overhead\" above to actually shrink the file.",
    storageOrphanUnavailable:
        "Not scannable yet. Refresh once the database has been loaded into server memory.",
    storageOrphanPurge: "Purge orphan media",
    storageOrphanPurging: "Purging orphan media...",
    storageOrphanConfirm: (count: number, size: number) =>
        `Delete ${count} unreferenced media file(s) (${(size / 1024 / 1024).toFixed(1)} MB)? This cannot be undone.`,
    storageOrphanDone: (count: number, size: number) =>
        `Deleted ${count} file(s) (${(size / 1024 / 1024).toFixed(1)} MB).`,
    storageOrphanFailed: "Orphan media purge failed",
    storageOrphanAutoClean: "Auto-purge on boot",
    storageOrphanAutoCleanDesc:
        "Delete orphan media every time the app opens. Off by default — it can also delete references the scanner does not know about yet, so manual purging is safer.",

    storageWalCleanup: "Manual WAL cleanup",
    storageWalCleanupHeader: (walSize: number) => `Current WAL ${(walSize / 1024 / 1024).toFixed(1)} MB`,
    storageWalCleanupWhat: "SQLite's WAL file (risuai.db-wal) collects recent changes before merging them into the main database. A background checkpoint runs every 5 minutes, but bursts like backup import or large asset uploads can temporarily inflate it.",
    storageWalCleanupWhen: "Use this when the WAL file looks large and you want to reclaim disk space immediately. Lightweight (a few milliseconds) and requires no extra free space, unlike Optimize. Data is not modified.",
    storageWalCleanup_btn: "Clean up WAL",
    storageWalCleanuping: "Cleaning up WAL...",
    storageWalCleanupConfirm: "Clean up WAL now? Server saves will pause briefly.",
    storageWalCleanupDone: (reclaimed: number, ms: number) =>
        `Reclaimed ${(reclaimed / 1024 / 1024).toFixed(1)} MB in ${ms}ms.`,
    storageWalCleanupNoop: "WAL is already clean.",
    storageWalCleanupFailed: "WAL cleanup failed",

    storageBackups: "Backups",
    storageBackupsManage: "Manage backups",
    storageBackupsAuto: "Snapshot (DB only)",
    storageBackupsAutoDesc: "Periodic automatic snapshots for quick recovery. Stored inside risuai.db; oldest are pruned first based on the configured limits. Character assets and inlay images are not included.",
    storageBackupsManual: "Server backup",
    storageBackupsManualDesc: "A full backup including character assets and inlay images. Stored directly on the server; the location can be changed.",
    storageBackupsCount: (count: number, size: number) =>
        `${count} · ${(size / 1024 / 1024).toFixed(1)} MB`,
    storageBackupsRange: (oldest: string, newest: string) => `Latest ${newest} · oldest ${oldest}`,
    storageBackupsEmpty: "None",

    storageCharacters: "Per-character usage",
    storageCharactersDesc: "Approximate card, media, and chat bytes for each character.",
    storageCharactersMeasure: "Measure",
    storageCharactersMeasuring: "Measuring...",
    storageCharactersDone: (ms: number, count: number) =>
        `Measured ${count.toLocaleString()} character(s) in ${(ms / 1000).toFixed(1)}s. Chat sizes are approximate.`,
    storageCharactersCard: "card",
    storageCharactersImage: "media",
    storageCharactersChat: "chat",
    storageCharactersTrashed: "trashed",
    storageCharactersGoTo: "Go to this character",
    storageCharactersOrphan: (count: number, size: number) =>
        `Orphan media (not referenced by any character): ${count} item(s), ${(size / 1024 / 1024).toFixed(1)} MB`,
    storageCharactersEmpty: "No characters",
    storageLoadMore: (remaining: number) => `Show more (${remaining.toLocaleString()} left)`,
    storageShowingOf: (shown: number, total: number) => `Showing ${shown.toLocaleString()} of ${total.toLocaleString()}`,

    storageModules: "Per-module usage",
    storageModulesDesc: "Body and asset bytes for each module.",
    storageModulesMeasure: "Measure",
    storageModulesMeasuring: "Measuring...",
    storageModulesDone: (ms: number, count: number) =>
        `Measured ${count.toLocaleString()} module(s) in ${(ms / 1000).toFixed(1)}s.`,
    storageModulesBody: "body",
    storageModulesAssets: "assets",
    storageModulesEmpty: "No modules",

    storageDebug: "Debug info",

    // Data migration (formerly "Account & Files")
    migration: "Data Migration",
    migrationDesc: "Move data between RisuAI (or compatible systems) and PocketRisu: import from upstream, or export to upstream-compatible format.",
    migrationInfoBackupMoved: "Server backups, local backups, and DB snapshots have moved to [System → Backups].",
    migrationGotoBackupTab: "Open Backups tab",
    migrationLegacyAccordion: "RisuAI-style backup (legacy)",
    migrationLegacyDesc: "Helpers for backing up and exporting in upstream RisuAI-compatible formats. Use the Backups tab for everyday backup tasks.",
    migrationSaveFolderAccordion: "Import save folder from NodeRisu",
    migrationSaveFolderDesc: "Use this to bring data over from a NodeRisu / RisuAI save folder you used previously.",
    migrationLoadUpstreamBackup: "Load upstream RisuAI local backup",

    // System → Backups tab
    systemBackups: "Backups",
    backupTabDesc: "Manage snapshots, full backups, and local backups in one place.",

    backupSnapshot: "Snapshot (DB only)",
    backupSnapshotEmpty: "No snapshots.",
    backupSnapshotRestore: "Restore from this snapshot",
    backupSnapshotDelete: "Delete snapshot",
    backupSnapshotDeleteConfirm: (when: string) => `Delete the ${when} snapshot? This cannot be undone.`,
    backupSnapshotDeleted: "Snapshot deleted.",
    backupSnapshotDeleteFailed: "Failed to delete snapshot",
    backupSnapshotLimits: (count: number, bytes: number) =>
        `Up to ${count} · ${(bytes / 1024 / 1024).toFixed(0)} MB`,
    backupSnapshotLimitsCurrent: (count: number, bytes: number, logicalBytes?: number) => {
        const disk = (bytes / 1024 / 1024).toFixed(1)
        const saved = (logicalBytes ?? 0) - bytes
        // Only surface the dedup win when it's meaningful (chunked snapshots share
        // chunks); for tiny/un-chunked sets logical ≈ disk, so the plain line reads
        // cleaner without a "(0 MB saved)" tail.
        if (saved > 1024 * 1024) {
            const data = ((logicalBytes ?? 0) / 1024 / 1024).toFixed(0)
            const savedMB = (saved / 1024 / 1024).toFixed(0)
            return `Currently ${count} · ${disk} MB on disk (${data} MB of data, ${savedMB} MB saved by deduplication)`
        }
        return `Currently ${count} · ${disk} MB used`
    },
    backupSnapshotLimitsChange: "Configure limits",
    backupSnapshotLimitsDialog: "Snapshot retention limits",
    backupSnapshotLimitsDialogDesc: "Whichever limit is reached first applies. Snapshots are rotated as new ones are created; reducing a limit trims immediately (the most recent snapshot is always kept regardless).",
    backupSnapshotLimitsCount: "Max count",
    backupSnapshotLimitsBytes: "Max size (MB)",
    backupSnapshotLimitsSuccess: (removed: number) =>
        removed > 0 ? `Limits applied (${removed} removed)` : "Limits updated.",
    backupSnapshotLimitsFailed: "Failed to update limits",
    backupSnapshotLimitsCountRange: (min: number, max: number) =>
        `Integer between ${min} and ${max}`,
    backupSnapshotLimitsBytesRange: (minMB: number, maxMB: number) =>
        `Between ${minMB} and ${maxMB.toLocaleString()} MB`,

    backupServer: "Server backup",
    backupServerDesc: "A full backup including character assets and inlay images. Stored directly on the server; you can change the location below.",
    backupServerCreate: "Create backup",
    backupServerEmpty: "No backups saved.",
    backupBootReminder: "Boot-time backup reminder",
    backupBootReminderHint: "From the next boot, ask whether to back up before showing the app.",
    backupBootReminderToggledOn: "Boot-time backup reminder enabled.",
    backupBootReminderToggledOff: "Boot-time backup reminder disabled.",
    backupBootPromptTitle: "Create a server backup now?",
    backupBootPromptEstimate: (size: number) =>
        `Estimated backup size: ${(size / 1024 / 1024).toFixed(0)} MB`,
    backupBootPromptDisk: (free: number, total: number) =>
        `Disk free: ${(free / 1024 / 1024 / 1024).toFixed(1)} GB / total ${(total / 1024 / 1024 / 1024).toFixed(1)} GB`,
    backupBootPromptProceed: "Back up now",
    backupBootPromptSkip: "Skip",
    storageDiskUsageHighWarning: (pct: number) =>
        `Disk ${pct.toFixed(0)}% full — cleanup needed.`,
    backupServerInsufficient: "Insufficient disk space — cannot create a new backup.",
    updatePopupBackup: "Backup",

    backupServerPath: "Stored at",
    backupServerPathDefault: "Default location",
    backupServerPathChange: "Change",
    backupServerPathDialog: "Change backup location",
    backupServerPathDialogDesc: "Absolute path to the folder where new backups will be saved. Existing backup files remain at the old location — move them manually if needed.",
    backupServerPathInputLabel: "Absolute path",
    backupServerPathSuccess: "Backup location updated.",
    backupServerPathFailed: "Failed to update backup location",

    backupLocal: "Local backup",
    backupLocalDesc: "Download a backup to your device or restore from a file on your device.",
    backupLocalDownload: "Download backup to device",
    backupLocalDownloadDesc: "Generate a fresh backup from current data and download it directly to your device.",
    backupLocalRestoreDesc: "Restore from a backup file on your device.",

    backupSettingsOnly: "Export settings only",
    backupSettingsOnlyDesc: "Export settings without characters, chats or inlay images. Modules, plugins, prompt presets, personas, lorebooks, theme and API keys are all included. Use this to seed a new instance.",
    backupSettingsOnlyEstimating: "Calculating size...",
    backupSettingsOnlyConfirm: (size: string) =>
        `Build a settings backup to carry over to a new instance. About ${size}.\n\n• Included: settings, API keys, modules, plugins, presets, personas, lorebooks, theme\n• Left out: characters, chat history, inlay images\n\nRestoring overwrites the existing data on that device. Prefer a fresh instance over one that already has characters.`,
    backupSettingsOnlyBreakdown: (
        baseSize: string,
        moduleCount: number,
        assetCount: number,
        moduleSize: string,
    ) =>
        `Build a settings backup to carry over to a new instance. Characters, chat history and inlay images are left out.\n\n• Settings, API keys, modules, plugins, presets, personas, lorebooks, theme: ${baseSize}\n• Module assets (${moduleCount} module(s), ${assetCount.toLocaleString()} images): ${moduleSize}\n\nLeaving the assets out still carries the modules themselves. Their images will be blank until you re-download those modules on the new instance.`,
    backupSettingsOnlyWithModuleAssets: (size: string) => `Include module assets (${size})`,
    backupSettingsOnlyWithoutModuleAssets: (size: string) => `Settings only (${size})`,
    backupSettingsOnlyModuleAssetsSkipped: "Settings backup saved.\n\n**Module assets were not included.** The restored instance will show your modules and their settings, but their images will be blank. Re-download those modules there to fill them back in.",

    relatedGithub: "GitHub",
    relatedGithubDesc: "Star this project to show your support.",
    support: "Support",
    supportBanner: "Support PocketRisu",
    supportTitle: "Support PocketRisu",
    supportThanks: "Thank you for your support",
    supportButton: "Support on Patreon",
    supportSetName: "Publish your supporter name",
    supportNotice: "Supporting PocketRisu is entirely voluntary — aside from having your name listed, it doesn't grant any additional features or benefits.",
    // Korean-only community-rule notice. Empty here so other locales inherit nothing and the block stays hidden.
    supportNoticeWarn: "",
    supportStatActive: "Current supporters",
    supportStatLifetime: "All-time supporters",
    supportCaptionActive: "The people who are with us every month",
    supportCaptionLifetime: "Everyone who has supported us so far",
    supportPerMonth: "mo",
    supportEmpty: "Be the first supporter",
    supportLoadFailed: "Couldn't load the supporter list",
    supportRetry: "Retry",
    supportDisabled: "Update checks are disabled on this server, so the supporter list is unavailable",
    supportUpstream: "Support the original RisuAI",
    relatedFeedbackForm: "Feedback Form",
    relatedFeedbackFormDesc: "Submit issues or share suggestions.",
    relatedContactEmail: "Contact",
    relatedContactEmailDesc: "Send a direct email to the developer.",
    relatedArcaLive: "ArcaLive Channel",
    relatedArcaLiveDesc: "Discuss with other users in the AI chat channel.",

    selectBotHint: "Select a bot to start chatting",
    recentChatsTitle: "Recent Chats",
    noRecentChatsDesc: "No conversations yet",
    hideRecentChats: "Hide conversation list",
    moveInsteadOfCopyOnCMPConvert: "Move Instead of Copy on CMP Convert",

    showRequestStatus: "Show request status",
    requestStatus: {
        connecting: "Connecting…",
        thinking: "Thinking…",
        responding: "Responding…",
        retrying: "Retrying…",
        stalled: "Stalled…",
        background: "In background…",
        done: "Done",
        failed: "Failed",
        aborted: "Cancelled",
        kindMain: "Main",
        kindTranslate: "Translate",
        kindMemory: "Memory",
        kindEmotion: "Emotion",
        kindSub: "Sub",
        outputTokens: "out",
        thinkingTokensLabel: "think",
        tokensPerSec: "tok/s",
        cacheHit: "Cache hit · {n} tokens",
    },

} satisfies I18nTranslation;

type I18nTranslationFunction = (...args: any[]) => string;

type I18nTranslation = {
    [key: string]: string | I18nTranslation | string[] | I18nTranslationFunction
}
